import { React, useState, useEffect } from "react";
import { Button, Form, Icon, Grid, Dropdown, Divider, Checkbox, Accordion, Card, Label, Popup } from "semantic-ui-react";
// Lodash
import { isEmpty, map, get, isEqual, maxBy, filter, omit, find, reject, orderBy, trim, compact, size, split } from "lodash";
// PropTypes
import PropTypes from "prop-types";
import Joi from "joi";

// Components
import Input from "@Components/Input";
import genericAction from "@Actions/generic";
import { connect } from "react-redux";
import IKModal from "@Components/IkModal";
import Text from "@Components/Text";
import TextAreaInput from "@Components/TextArea";
import ColorPickerDropdown from "@Features/Tags/Component/DropDownColor";
// Modals
import ConfirmModal from "@Modals/ConfirmModal";

// Utils
import { dropdownFormat } from "@Utils/formats";

// Styles
import styles from "./styles.module.css";

// StaticData
export const fieldTypes = [
	{ name: "string", value: "Texto" },
	{ name: "note", value: "Nota" },
	{ name: "number", value: "Numérico" },
	{ name: "date", value: "Fecha" },
	{ name: "enum", value: "Dropdown" },
	{ name: "password", value: "Clave" },
	{ name: "image", value: "Imagen" },
	{ name: "list", value: "Lista" },
	{ name: "label", value: "Label" },
	{ name: "direction", value: "Dirección" },
	{ name: "bool", value: "Booleano" },
	{ name: "formula", value: "Formula" },
	{ name: "code", value: "Código" },
	{ name: "group", value: "Grupo" },
].sort((a, b) => {
	return a.value.localeCompare(b.value);
});

const SystemLogFieldCrud = ({ onClose, data, tableData, modalMode, modalOptionCompany, dispatch, companyId, systemLogFieldHandler }) => {
	SystemLogFieldCrud.propTypes = {
		data: PropTypes.object,
		systemLogFieldHandler: PropTypes.func,
		dispatch: PropTypes.func,
		companyId: PropTypes.number,
		onClose: PropTypes.func,
		modalMode: PropTypes.string,
		tableData: PropTypes.array,
		modalOptionCompany: PropTypes.string,
	};

	// hooks
	const [openConfirmModal, setOpenConfirmModal] = useState(false);

	const [deleteAlert, setDeleteAlert] = useState(false);
	const [itemToDelete, setItemToDelete] = useState(null);

	const [deleteLabelAlert, setDeleteLabelAlert] = useState(false);
	const [itemToLabelDelete, setItemToLabelDelete] = useState(null);

	const [deleteFormulaAlert, setDeleteFormulaAlert] = useState(false);
	const [itemToFormulaDelete, setItemToFormulaDelete] = useState(null);

	const [deleteLabelEntryAlert, setDeleteLabelEntryAlert] = useState(false);
	const [itemToDeleteLabelEntry, setItemToDeleteLabelEntryAlert] = useState(null);

	const [deleteFormulaEntryAlert, setDeleteFormulaEntryAlert] = useState(false);
	const [itemToDeleteFormulaEntry, setItemToDeleteFormulaEntryAlert] = useState(null);

	const [isList, setIsList] = useState(false);
	const [showAllEntries, setShowAllEntries] = useState(false);

	const [allExpanded, setAllExpanded] = useState(false);

	// dropDownData
	const [typesData, setTypesData] = useState([]);
	const [typseDataBorn, setTypesDataBorn] = useState([]);
	const [formEntries, setFormEntries] = useState([]);
	const [modalOption, setModalOption] = useState("");
	const [optionsLabel, setOptionsLabel] = useState([]);
	const [dataG, setDataG] = useState([]);

	// formData
	const [initialFormData, setInitialFormData] = useState({});
	const [errors, setErrors] = useState({});
	const [formData, setFormData] = useState({
		isUpdateable: false,
		isVisible: true,
		isMultiple: false,
		isRequired: false,
		isOpen: false,
		type: "",
		label: "",
		options: "",
		minDigits: null,
		maxDigits: null,
		icon: "",
		order: "",
		value: "",
		placeholder: "",
		formula: "",
		question: "",
		question2: "",
	});

	const schema = Joi.object().keys({
		label: Joi.string().min(2).messages({
			"string.min": "Nombre debe tener mínimo 2 caracteres",
			"string.empty": "Nombre es un campo requerido",
		}),
		type: Joi.string().messages({
			"string.empty": "Tipo es un campo requerido",
		}),
		formula: Joi.when("type", {
			is: "formula",
			then: Joi.string().trim().required().messages({
				"string.empty": "La formula es obligatoria",
				"any.required": "La formula es obligatoria",
			}),
		}),
		formulaOptions: Joi.array().messages({
			"array.base": "La formula tiene opciones obligatorias",
		}),
		nameFormula: Joi.when("formulaOptions", {
			is: Joi.array().min(1),
			then: Joi.array().items(Joi.string().min(2).required()).min(1).messages({
				"string.min": "Nombre debe tener mínimo 2 caracteres",
				"array.includesRequiredUnknowns": "Nombre es un campo requerido",
			}),
			otherwise: Joi.optional(),
		}),
		textOptions: Joi.array().messages({
			"array.base": "El Texto tiene opciones obligatorias",
		}),
		nameText: Joi.when("textOptions", {
			is: Joi.array().min(1),
			then: Joi.array().items(Joi.string().min(2).required()).min(1).messages({
				"string.min": "Nombre debe tener mínimo 2 caracteres",
				"array.includesRequiredUnknowns": "Nombre es un campo requerido",
			}),
			otherwise: Joi.optional(),
		}),
		numberOptions: Joi.array().messages({
			"array.base": "El Texto tiene opciones obligatorias",
		}),
		nameNumber: Joi.when("numberOptions", {
			is: Joi.array().min(1),
			then: Joi.array().items(Joi.string().min(2).required()).min(1).messages({
				"string.min": "Nombre debe tener mínimo 2 caracteres",
				"array.includesRequiredUnknowns": "Nombre es un campo requerido",
			}),
			otherwise: Joi.optional(),
		}),
		formulaOptionsEntry: Joi.when("typeEntries", {
			is: Joi.array().min(1).items(Joi.string().valid("formula")),
			then: Joi.array().items(Joi.string().required()).messages({
				"array.includesRequiredUnknowns": "Formula es un campo requerido",
			}),
			otherwise: Joi.optional(),
		}),
		formEntries: Joi.when("type", {
			is: "list",
			then: Joi.array().min(1).messages({
				"array.min": "Debes agregar al menos 1 registro",
			}),
			otherwise: Joi.optional(),
		}),
		entriesLabel: Joi.when("formEntries", {
			is: Joi.array().min(1),
			then: Joi.array().items(Joi.string().min(2).required()).min(1).messages({
				"string.min": "Nombre debe tener mínimo 2 caracteres",
				"array.includesRequiredUnknowns": "Nombre es un campo requerido",
			}),
			otherwise: Joi.optional(),
		}),
		typeEntries: Joi.when("type", {
			is: "list",
			then: Joi.when("formEntries", {
				is: Joi.array().min(1),
				then: Joi.array().items(Joi.string().required()).messages({
					"array.includesRequiredUnknowns": "Debe contener al menos un Tipo",
				}),
				otherwise: Joi.optional(),
			}),
			otherwise: Joi.optional(),
		}),
		nameLabel: Joi.when("formLabel", {
			is: Joi.array().min(1),
			then: Joi.array().items(Joi.string().min(2).required()).min(1).messages({
				"string.min": "Nombre debe tener mínimo 2 caracteres",
				"array.includesRequiredUnknowns": "Nombre es un campo requerido",
			}),
			otherwise: Joi.optional(),
		}),
		nameEnum: Joi.when("formEnum", {
			is: Joi.array().min(1),
			then: Joi.array().items(Joi.string().min(2).required()).min(1).messages({
				"string.min": "Nombre debe tener mínimo 2 caracteres",
				"array.includesRequiredUnknowns": "Nombre es un campo requerido",
			}),
			otherwise: Joi.optional(),
		}),
		formLabel: Joi.when("type", {
			is: "label",
			then: Joi.array().min(1).messages({
				"array.min": "Debes agregar al menos 1 opción",
			}),
			otherwise: Joi.optional(),
		}),
		formEnum: Joi.when("type", {
			is: "enum",
			then: Joi.array().min(1).messages({
				"array.min": "Debes agregar al menos 1 opción",
			}),
			otherwise: Joi.optional(),
		}),
		labelTypeEntry: Joi.when("typeEntries", {
			is: Joi.array().min(1).items(Joi.string().valid("label")),
			then: Joi.array().items(Joi.string().min(2).required()).messages({
				"array.includesRequiredUnknowns": "Nombre es un campo requerido",
				"string.min": "Nombre debe tener mínimo 2 caracteres",
			}),
			otherwise: Joi.optional(),
		}),
		EnumTypeEntry: Joi.when("typeEntries", {
			is: Joi.array().min(1).items(Joi.string().valid("enum")),
			then: Joi.array().items(Joi.string().min(2).required()).messages({
				"array.includesRequiredUnknowns": "Nombre es un campo requerido",
				"string.min": "Nombre debe tener mínimo 2 caracteres",
			}),
			otherwise: Joi.optional(),
		}),
		formulaOptionsFormEntry: Joi.optional(),
		formulaNameEntry: Joi.when("formulaOptionsFormEntry", {
			is: Joi.array().min(1),
			then: Joi.array().items(Joi.string().min(2).required()).messages({
				"string.min": "Nombre debe tener mínimo 2 caracteres",
				"array.includesRequiredUnknowns": "Nombre es un campo requerido",
			}),
			otherwise: Joi.optional(),
		}),
		textOptionsFormEntry: Joi.optional(),
		textEntry: Joi.when("textOptionsFormEntry", {
			is: Joi.array().min(1),
			then: Joi.array().items(Joi.string().min(2).required()).messages({
				"string.min": "Nombre debe tener mínimo 2 caracteres",
				"array.includesRequiredUnknowns": "Nombre es un campo requerido",
			}),
			otherwise: Joi.optional(),
		}),
		numberOptionsFormEntry: Joi.optional(),
		numberEntry: Joi.when("numberOptionsFormEntry", {
			is: Joi.array().min(1),
			then: Joi.array().items(Joi.string().min(2).required()).messages({
				"string.min": "Nombre debe tener mínimo 2 caracteres",
				"array.includesRequiredUnknowns": "Nombre es un campo requerido",
			}),
			otherwise: Joi.optional(),
		}),
		formLabelEntry: Joi.when("typeEntries", {
			is: Joi.array().min(1).items(Joi.string().valid("label")),
			then: Joi.array().min(1).messages({
				"array.min": "Debes agregar al menos 1 opción",
			}),
			otherwise: Joi.optional(),
		}),
		formEnumEntry: Joi.when("typeEntries", {
			is: Joi.array().min(1).items(Joi.string().valid("enum")),
			then: Joi.array().min(1).messages({
				"array.min": "Debes agregar al menos 1 opción",
			}),
			otherwise: Joi.optional(),
		}),
	});

	// Effects
	useEffect(() => {
		setModalOption(modalMode);
		if (data) {
			const systemLogFieldData = data.systemLogField;
			let newData = {};

			if (modalMode !== "Add") {
				newData = {
					...formData,
					isUpdateable: get(systemLogFieldData, "isUpdateable", false),
					isRequired: get(systemLogFieldData, "isRequired", false),
					isOpen: get(systemLogFieldData, "isOpen", false),
					order: get(systemLogFieldData, "order", ""),
					label: get(systemLogFieldData, "label", ""),
					isVisible: get(systemLogFieldData, "isVisible", true),
					isMultiple: get(systemLogFieldData, "isMultiple", false),
					type: get(systemLogFieldData, "type", ""),
					options: get(systemLogFieldData, "options", []),
					question: get(systemLogFieldData, "question", ""),
					question2: get(systemLogFieldData, "question2", ""),
					// length: get(systemLogFieldData, "length", []),
					minDigits: get(systemLogFieldData, "minDigits", []),
					maxDigits: get(systemLogFieldData, "maxDigits", []),
					formula: get(systemLogFieldData, "formula", ""),
					icon: get(systemLogFieldData, "icon", ""),
					placeholder: get(systemLogFieldData, "placeholder", ""),
				};
				const optionLabelMap = map(get(systemLogFieldData, "options", []), (item) => {
					return { ...item, active: false };
				});
				setOptionsLabel(optionLabelMap);
			} else {
				const orders = map(tableData, (item) => {
					return item.order;
				}).filter((item) => {
					return item !== undefined;
				});
				const maxOrder = orders.length > 0 ? Math.max(...orders) : 0;
				const suggestOrder = maxOrder + 1;
				newData = { ...formData, order: suggestOrder };
			}

			if (newData.type === "list") {
				setIsList(true);
			}
			setFormData(newData);
			const omitList = filter(dropdownFormat(fieldTypes, "value", "name"), (option) => {
				return option.value !== "list";
			});
			setTypesDataBorn(omitList);

			const currentEntries = map(get(systemLogFieldData, "items", []), (item, index) => {
				const newOptions =
					item.type === "formula"
						? map(item.options || [], (optionss) => {
								return { ...optionss, active: false };
						  })
						: item.options;

				return {
					...item,
					id: index + 1,
					length: String(item.length),
					formula: item.formula || "",
					options: newOptions,
				};
			});

			setFormEntries(currentEntries);
			setInitialFormData(newData);
			setDataG(systemLogFieldData);
		}

		dropDownData(data);
	}, [data]);

	// modal handlers
	const confirmModal = () => {
		onClose();
	};

	const closeModal = () => {
		if (isEqual(initialFormData, formData)) {
			onClose();
		} else {
			setOpenConfirmModal(true);
		}
	};

	// input handlers
	const handleInput = (e, { name, value, index }) => {
		if (index !== undefined) {
			const updatedEntries = [...formEntries];
			if (name === "options" && updatedEntries[index].type === "string") {
				// Si es tipo string, actualizar como array de objetos
				updatedEntries[index].options = [{ id: 1, name: value, active: false }];
			} else {
				updatedEntries[index][name] = value;
			}
			setFormEntries(updatedEntries);
		} else {
			setFormData((prevFormData) => {
				return { ...prevFormData, [name]: value };
			});
		}
	};

	const handleInputQuestion = (e, dataq) => {
		let name;
		let value;

		if (e?.target) {
			name = e.target.name;
			value = e.target.value;
		} else if (dataq) {
			name = dataq.name;
			value = dataq.value;
		}

		if (!name) return;

		if (dataq?.index !== undefined) {
			const updatedEntries = [...formEntries];
			updatedEntries[dataq.index][name] = value;
			setFormEntries(updatedEntries);
		} else {
			setFormData((prev) => {
				return {
					...prev,
					[name]: value,
				};
			});
		}
	};

	const filteredCompanyFields = orderBy(tableData, ["order"], ["asc"]);

	// const filteredCompanyFields = (companyFields).filter((item) => item.label);

	const handleCheckBox = (e, { name, checked }) => {
		if (name === "isRequired" && checked) {
			setFormData({
				...formData,
				isRequired: true,
				isUpdateable: true,
			});
		} else if (name === "isUpdateable" && !checked) {
			setFormData({
				...formData,
				isUpdateable: false,
				isRequired: false,
			});
		} else {
			setFormData({
				...formData,
				[name]: checked,
			});
		}
	};

	const handleInputDropdown = (e, { name, value, index }) => {
		if (index !== undefined) {
			const updatedEntries = [...formEntries];
			updatedEntries[index][name] = value;
			updatedEntries[index].isList = value === "list";
			setFormEntries(updatedEntries);
		} else {
			setFormData((prevFormData) => {
				let newFormData = { ...prevFormData, [name]: value };

				if (name === "type") {
					newFormData = {
						...newFormData,
						// length: "",
						options: "",
					};

					if (value !== "list") {
						setFormEntries([]);
						setIsList(false);
					} else {
						const omitList = filter(typesData, (option) => {
							return option.value !== "list";
						});
						setTypesDataBorn(omitList);
						setIsList(true);
					}
					if (value !== "label") {
						setOptionsLabel([]);
					}
				}
				return newFormData;
			});
		}
	};

	const handleDeleteRequest = (e, entry, hasArray) => {
		e.stopPropagation();
		let hasData = false;

		for (const item of hasArray) {
			if (!isEmpty(entry[item])) {
				hasData = true;
			}
		}

		if (entry.isRequired) {
			setItemToDelete(entry);
			setDeleteAlert(true);
			return;
		}

		if (!entry.isVisible) {
			setItemToDelete(entry);
			setDeleteAlert(true);
			return;
		}

		if (entry.isUpdateable) {
			setItemToDelete(entry);
			setDeleteAlert(true);
			return;
		}

		if (hasData) {
			setItemToDelete(entry);
			setDeleteAlert(true);
		} else {
			setFormEntries((prevEntries) => {
				return prevEntries.filter((item) => {
					return item.id !== entry.id;
				});
			});
		}
	};

	const handleDeleteConfirm = () => {
		if (itemToDelete) {
			setFormEntries((prevEntries) => {
				return prevEntries
					.filter((entry) => {
						return entry.id !== itemToDelete.id;
					})
					.map((entry) => {
						return {
							...entry,
							active: entry.active,
						};
					});
			});
		}
		setDeleteAlert(false);
		setItemToDelete(null);
	};

	const dropDownData = () => {
		setTypesData(dropdownFormat(fieldTypes, "value", "name"));
	};

	const getNewId = (currentData) => {
		if (isEmpty(currentData)) {
			return 1;
		}
		const maxId = maxBy(currentData, "id");
		return get(maxId, "id", 0) + 1;
	};

	const addListEntry = () => {
		const maxOrder = maxBy(formEntries, (item) => {
			return parseInt(item.order, 10);
		});
		const newOrder = maxOrder ? parseInt(maxOrder.order, 10) + 1 : 1;

		const isFirstEntry = formEntries.length === 0;
		const lastEntryState = !isFirstEntry ? formEntries[formEntries.length - 1].active : true;

		setFormEntries([
			...formEntries,
			{
				...formData,
				id: getNewId(formEntries),
				isList: formData.type === "list",
				label: "",
				isVisible: true,
				isMultiple: false,
				isUpdateable: false,
				isRequired: false,
				type: "",
				options: [],
				formula: "",
				minDigits: "",
				maxDigits: "",
				icon: "",
				placeholder: "",
				order: newOrder,
				active: lastEntryState,
				question: "",
				question2: "",
			},
		]);
	};

	const getErrorListError = (errorList) => {
		for (const item of errorList) {
			if (item) {
				const currentError = item.errors;
				if (
					currentError.typeEntries !== "" ||
					currentError.entriesLabel !== "" ||
					currentError.labelTypeEntry !== "" ||
					currentError.EnumTypeEntry !== "" ||
					currentError.formulaNameEntry !== "" ||
					currentError.formLabelEntry !== "" ||
					currentError.formEnumEntry !== "" ||
					// currentError.number !== "" ||
					// currentError.password !== "" ||
					currentError.textEntry !== ""
				) {
					return true;
				}
			}
		}
		return false;
	};

	const getErrorLabelError = (errorLabel) => {
		for (const items of errorLabel) {
			if (items) {
				const currentError = items.errors;
				if (currentError.name !== "" || currentError.color !== "") {
					return true;
				}
			}
		}
		return false;
	};

	const getErrorEnumError = (errorEnum) => {
		for (const items of errorEnum) {
			if (items) {
				const currentError = items.errors;
				if (currentError.name !== "") {
					return true;
				}
			}
		}
		return false;
	};

	const getErrorTextError = (errorText) => {
		let hasError = false;
		map(errorText, (currentError) => {
			if (currentError && (currentError.textEntry !== "" || currentError.textOptionsFormEntry !== "")) {
				hasError = true;
			}
		});
		return hasError;
	};

	const getErrorNumberError = (errorText) => {
		for (const items of errorText) {
			if (items) {
				const currentError = items.errors;
				if (currentError.name !== "") {
					return true;
				}
			}
		}
		return false;
	};

	const getErrorFormulaError = (errorFormula) => {
		for (const items of errorFormula) {
			if (items) {
				const currentError = items.errors;
				if (currentError.name !== "") {
					return true;
				}
			}
		}
		return false;
	};

	const save = async () => {
		const lastOrder = maxBy(tableData, (item) => {
			return parseInt(item.order, 10);
		});
		const nextOrder = lastOrder ? parseInt(lastOrder.order, 10) + 1 : 1;
		const orderData = formData.order !== "" ? parseInt(formData.order, 10) : nextOrder;

		// const lastOrder = maxBy(tableData, (item) => parseInt(item.order, 10));
		// const nextOrder = lastOrder ? parseInt(lastOrder.order, 10) + 1 : 1;
		// let orderData = formData.order === "" && initialFormData.order ? parseInt(initialFormData.order, 10) : parseInt(formData.order, 10) || nextOrder;

		const lastEntryOrder = maxBy(formEntries, (entry) => {
			return parseInt(entry.order, 10);
		});
		const nextEntryOrder = lastEntryOrder ? parseInt(lastEntryOrder.order, 10) + 1 : 1;

		const mapEntriesContent = map(formEntries, (itemQa) => {
			const mapEntry = [get(itemQa, "length", "")];
			const mapEntryType = [itemQa.type];
			// const mapOptions = [get(itemQa.options, "[0]", "")];
			const mapEntryName = [itemQa.label];
			const mapOptionsFormula = [itemQa.formula];

			const mapOptionsEntryContent = map(get(itemQa, "options", []), (itemQa2) => {
				const payload = {
					label: formData.label,
					type: formData.type,
					formula: formData.formula,
					formEntries,
					// options: formData.options,
					entriesLabel: itemQa.label ? [itemQa.label] : [],
					typeEntries: [itemQa.type],
					firstPassword: `${formData.minDigits}-${formData.maxDigits}`,
					firstNumber: `${formData.minDigits}-${formData.maxDigits}`,
				};

				if (itemQa.type === "formula") {
					payload.formulaOptionsEntry = [itemQa.formula];
					payload.formulaNameEntry = [get(itemQa2, "name", "")];
					payload.formulaOptionsFormEntry = [get(itemQa2, "formula", "")];
				}

				if (itemQa.type === "string") {
					payload.textOptionsFormEntry = [get(itemQa2, "name", "")];
					payload.textEntry = [get(itemQa2, "name", "")];

					const validation = schema.validate(payload, { abortEarly: false });
					if (validation.error) {
						let errorss = {
							textEntry: "",
							textOptionsFormEntry: "",
						};
						map(validation.error.details, (item) => {
							errorss = { ...errorss, [item.context.key]: item.message };
						});
						return {
							id: itemQa2.id,
							errors: errorss,
						};
					}
				}

				if (itemQa.type === "number") {
					payload.numberOptionsFormEntry = [get(itemQa2, "name", "")];
					payload.numberEntry = [get(itemQa2, "name", "")];

					const validation = schema.validate(payload, { abortEarly: false });
					if (validation.error) {
						let errorss = {
							numberEntry: "",
							numberOptionsFormEntry: "",
						};
						map(validation.error.details, (item) => {
							errorss = { ...errorss, [item.context.key]: item.message };
						});
						return {
							id: itemQa2.id,
							errors: errorss,
						};
					}
				}

				if (itemQa.type === "label") {
					payload.labelTypeEntry = [get(itemQa2, "name", "")];
					payload.formLabelEntry = [get(itemQa2, "label", "")];
				}

				if (itemQa.type === "enum") {
					payload.formEnumEntry = [get(itemQa2, "label", "")];
					payload.EnumTypeEntry = [get(itemQa2, "name", "")];
				}

				if (["password", "number"].includes(itemQa.type)) {
					payload[itemQa.type] = get(itemQa, "length", "");
				}

				const validation = schema.validate(payload, { abortEarly: false });

				if (validation.error) {
					let errorss = {
						label: "",
						type: "",
						formula: "",
						// number: "",
						entriesLabel: "",
						labelTypeEntry: "",
						EnumTypeEntry: "",
						formulaNameEntry: "",
						// firstPassword: "",
						formulaOptionsEntry: "",
						formulaOptionsFormEntry: "",
						// firstNumber: "",
						typeEntries: "",
						// password: "",
						formLabelEntry: "",
						formEnumEntry: "",
						textEntry: "",
						numberEntry: "",
					};
					map(validation.error.details, (itemsa) => {
						errorss = { ...errorss, [itemsa.context.key]: itemsa.message };
					});
					return {
						id: itemQa2.id,
						errors: errorss,
					};
				}
				return null;
			});

			const payload = {
				label: formData.label,
				type: formData.type,
				formula: formData.formula,
				typeEntries: mapEntryType,
				entriesLabel: mapEntryName,
				number: mapEntry,
				password: mapEntry,
				formEntries,
				options: formData.options,
				// optionsSecond: mapOptions,
				formulaOptionsEntry: mapOptionsFormula,
				formulaOptionsFormEntry: [],
				firstPassword: `${formData.minDigits}-${formData.maxDigits}`,
				firstNumber: `${formData.minDigits}-${formData.maxDigits}`,
			};

			if (itemQa.type === "formula") {
				payload.formulaNameEntry = map(get(itemQa, "options", []), (option) => {
					return get(option, "name", "");
				});
				payload.textEntry = map(get(itemQa, "options", []), (option) => {
					return get(option, "name", "");
				});
				payload.numberEntry = map(get(itemQa, "options", []), (option) => {
					return get(option, "name", "");
				});
				payload.formulaOptionsFormEntry = map(get(itemQa, "options", []), (option) => {
					return get(option, "formula", "");
				});
			}

			if (itemQa.type === "label") {
				payload.labelTypeEntry = map(get(itemQa, "options", []), (option) => {
					return get(option, "name", "");
				});
				payload.formLabelEntry = map(get(itemQa, "options", []), (option) => {
					return get(option, "label", "");
				});
			}

			if (itemQa.type === "enum") {
				payload.formEnumEntry = map(get(itemQa, "options", []), (option) => {
					return get(option, "label", "");
				});
				payload.EnumTypeEntry = map(get(itemQa, "options", []), (option) => {
					return get(option, "name", "");
				});
			}

			const validation = schema.validate(payload, { abortEarly: false });

			if (validation.error) {
				let errorss = {
					label: "",
					type: "",
					formula: "",
					entriesLabel: "",
					labelTypeEntry: "",
					EnumTypeEntry: "",
					textEntry: "",
					formulaNameEntry: "",
					formulaOptionsEntry: "",
					formulaOptionsFormEntry: "",
					typeEntries: "",
					formLabelEntry: "",
					formEnumEntry: "",
					numberEntry: "",
					numberOptionsFormEntry: "",
				};
				map(validation.error.details, (itemsa) => {
					errorss = { ...errorss, [itemsa.context.key]: itemsa.message };
				});
				return {
					id: itemQa.id,
					errors: errorss,
					optionsError: mapOptionsEntryContent,
				};
			}

			return null;
		});

		let mapLabelContent = [];
		if (formData.type === "label") {
			mapLabelContent = map(optionsLabel, (itemLa) => {
				const mapLabelName = map([itemLa], (itemJA) => {
					return get(itemJA, "name", "");
				});
				const validation = schema.validate(
					{
						formLabel: optionsLabel,
						formEnum: optionsLabel,
						nameLabel: mapLabelName,
						nameEnum: mapLabelName,
					},
					{ abortEarly: false }
				);
				if (validation.error) {
					const { details } = validation.error;
					let errorss = {
						nameLabel: "",
						nameEnum: "",
						formLabel: "",
						formEnum: "",
					};
					map(details, (itemsa) => {
						errorss = { ...errorss, [itemsa.context.key]: itemsa.message };
					});
					return {
						id: itemLa.id,
						errors: errorss,
					};
				}
				return null;
			});
		}

		let mapFormulaContent = [];
		if (formData.type === "formula") {
			mapFormulaContent = map(optionsLabel, (itemFormula) => {
				const mapFormula = map([itemFormula], (item) => {
					return item.name;
				});
				const validation = schema.validate(
					{
						formulaOptions: optionsLabel,
						nameFormula: mapFormula,
					},
					{ abortEarly: false }
				);
				if (validation.error) {
					const { details } = validation.error;
					let errorss = {
						formulaOptions: "",
						nameFormula: "",
					};
					map(details, (itemsa) => {
						errorss = { ...errorss, [itemsa.context.key]: itemsa.message };
					});
					return {
						id: itemFormula.id,
						errors: errorss,
					};
				}
				return null;
			});
		}

		let mapEnumContent = [];
		if (formData.type === "enum") {
			mapEnumContent = map(optionsLabel, (itemEnum) => {
				const mapEnumName = map([itemEnum], (item) => {
					return get(item, "name", "");
				});
				const validation = schema.validate(
					{
						// formEnum: optionsLabel,
						nameEnum: mapEnumName,
					},
					{ abortEarly: false }
				);
				if (validation.error) {
					const { details } = validation.error;
					let errorss = {
						nameEnum: "",
						// formEnum: "",
					};
					map(details, (itemsa) => {
						errorss = { ...errorss, [itemsa.context.key]: itemsa.message };
					});
					return {
						id: itemEnum.id,
						errors: errorss,
					};
				}
				return null;
			});
		}

		let mapTextContent = [];
		if (formData.type === "string") {
			mapTextContent = map(optionsLabel, (itemText) => {
				const mapTextName = map([itemText], (item) => {
					return get(item, "name", "");
				});
				const validation = schema.validate(
					{
						textOptions: optionsLabel,
						nameText: mapTextName,
					},
					{ abortEarly: false }
				);
				if (validation.error) {
					const { details } = validation.error;
					let errorss = {
						nameText: "",
						textOptions: "",
					};
					map(details, (itemsa) => {
						errorss = { ...errorss, [itemsa.context.key]: itemsa.message };
					});
					return {
						id: itemText.id,
						errors: errorss,
					};
				}
				return null;
			});
		}

		let mapNumberContent = [];
		if (formData.type === "number") {
			mapNumberContent = map(optionsLabel, (itemNumber) => {
				const mapNumberName = map([itemNumber], (item) => {
					return get(item, "name", "");
				});
				const validation = schema.validate(
					{
						numberOptions: optionsLabel,
						nameNumber: mapNumberName,
					},
					{ abortEarly: false }
				);
				if (validation.error) {
					const { details } = validation.error;
					let errorss = {
						nameNumber: "",
						numberOptions: "",
					};
					map(details, (itemsa) => {
						errorss = { ...errorss, [itemsa.context.key]: itemsa.message };
					});
					return {
						id: itemNumber.id,
						errors: errorss,
					};
				}
				return null;
			});
		}

		const validation = schema.validate(
			{
				label: formData.label,
				type: formData.type,
				formula: formData.formula,
				formEntries,
				formLabel: optionsLabel,
				formEnum: optionsLabel,
				formulaOptions: [],
			},
			{ abortEarly: false }
		);
		const errorListHasError = getErrorListError(mapEntriesContent);
		const errorLabelHas = getErrorLabelError(mapLabelContent);
		const errorFormulaHas = getErrorFormulaError(mapFormulaContent);
		const errorEnumHas = getErrorEnumError(mapEnumContent);
		const errorTextHas = getErrorTextError(mapTextContent);
		const errorNumberHas = getErrorNumberError(mapNumberContent);
		if (validation.error || errorListHasError || errorLabelHas || errorFormulaHas || errorEnumHas || errorTextHas || errorNumberHas) {
			const details = get(validation.error, "details", []);
			let errorss = {
				label: "",
				type: "",
				formula: "",
				formulaOptions: "",
				entriesLabel: "",
				formLabelEntry: "",
				formEnumEntry: "",
				formulaOptionsFormEntry: "",
				formEntries: "",
				formLabel: "",
				formEnum: "",
				nameLabel: "",
				nameEnum: "",
				formulaOptionsEntry: "",
				typeEntries: "",
				textEntry: "",
			};
			map(details, (item) => {
				errorss = { ...errorss, [item.context.key]: item.message };
			});
			setErrors({
				...errorss,
				errorList: mapEntriesContent,
				errorLabel: mapLabelContent,
				errorFormula: mapFormulaContent,
				errorEnum: mapEnumContent,
				errorText: mapTextContent,
				errorNumber: mapNumberContent,
			});
		} else {
			const items = map(formEntries, (entry) => {
				let options = [];

				if (["enum", "number", "string"].includes(entry.type)) {
					const rawOptions = get(entry, "options", []);
					if (Array.isArray(rawOptions)) {
						options = rawOptions.map((opt) => {
							return { ...opt, active: false };
						});
					} else if (typeof rawOptions === "string") {
						options = rawOptions.trim() ? rawOptions.split(",") : [];
					}
				} else if (["label", "formula"].includes(entry.type)) {
					options = Array.isArray(entry.options)
						? entry.options.map((opt) => {
								return { ...opt, active: false };
						  })
						: [];
				} else if (entry.type === "group") {
					options = Array.isArray(entry.options) ? entry.options : [];
				}

				const minDigits = ["password", "number"].includes(entry.type) ? parseInt(entry.minDigits, 10) : undefined;
				const maxDigits = ["password", "number"].includes(entry.type) ? parseInt(entry.maxDigits, 10) : undefined;

				return {
					type: entry.type || null,
					label: entry.label || null,
					icon: entry.icon || "",
					order: entry.order && !Number.isNaN(Number(entry.order)) ? parseInt(entry.order, 10) : nextEntryOrder,
					value: "",
					isUpdateable: entry.isUpdateable || false,
					isVisible: entry.isVisible || false,
					isMultiple: entry.isMultiple || false,
					isRequired: entry.isRequired || false,
					placeholder: entry.placeholder || "",
					question: entry.question || "",
					question2: entry.question2 || "",
					options,
					...(entry.type === "formula" ? { formula: entry.formula || "" } : {}),
					...(minDigits !== undefined ? { minDigits } : {}),
					...(maxDigits !== undefined ? { maxDigits } : {}),
				};
			});

			const sendData = omit(formData, ["required"]);
			const updatedTableData = filter(tableData, (item) => {
				return item.label !== formData.label;
			});

			await dispatch(
				genericAction({
					method: "patch",
					route: `company/${companyId}`,
					body: {
						companyFields: [
							...updatedTableData,
							{
								...sendData,
								isRequired: formData.isRequired,
								isOpen: formData.isOpen,
								order: orderData,

								options: ["enum", "string", "number"].includes(formData.type)
									? optionsLabel.map((opt) => {
											return {
												name: typeof opt.name === "string" ? opt.name.trim() : "",
											};
									  })
									: formData.type === "formula"
									? optionsLabel.map((opt) => {
											return {
												name: typeof opt.name === "string" ? opt.name.trim() : "",
												unit: typeof opt.unit === "string" ? opt.unit.trim() : "",
											};
									  })
									: formData.type === "label"
									? optionsLabel.map((opt) => {
											return {
												name: typeof opt.name === "string" ? opt.name.trim() : "",
												color: typeof opt.color === "string" ? opt.color.trim() : "",
											};
									  })
									: formData.type === "group"
									? Array.isArray(formData.options)
										? formData.options
										: []
									: [],

								// length: parseInt(get(formData, "length", [])),
								minDigits: parseInt(get(formData, "minDigits", [])),
								maxDigits: parseInt(get(formData, "maxDigits", [])),
								formula: get(formData, "formula", ""),
								items,
							},
						],
					},
				}),
				modalOption,
				initialFormData
			);

			systemLogFieldHandler(
				{
					...sendData,
					isRequired: formData.isRequired,
					isOpen: formData.isOpen,
					order: orderData,

					options: ["enum", "string", "number"].includes(formData.type)
						? optionsLabel.map((opt) => {
								return {
									name: typeof opt.name === "string" ? opt.name.trim() : "",
								};
						  })
						: formData.type === "formula"
						? optionsLabel.map((opt) => {
								return {
									name: typeof opt.name === "string" ? opt.name.trim() : "",
									unit: typeof opt.unit === "string" ? opt.unit.trim() : "",
								};
						  })
						: formData.type === "label"
						? optionsLabel.map((opt) => {
								return {
									name: typeof opt.name === "string" ? opt.name.trim() : "",
									color: typeof opt.color === "string" ? opt.color.trim() : "",
								};
						  })
						: formData.type === "group"
						? Array.isArray(formData.options)
							? formData.options
							: []
						: [],
					// length: parseInt(get(formData, "length", [])),
					minDigits: parseInt(get(formData, "minDigits", [])),
					maxDigits: parseInt(get(formData, "maxDigits", [])),
					formula: get(formData, "formula", ""),
					items,
				},
				modalOption,
				initialFormData
			);
			setFormData({
				label: "",
				type: "",
				typeEntries: [],
				entriesLabel: [],
				number: "",
				password: "",
				formEntries: [],
				formLabel: "",
				formEnum: "",
				nameLabel: "",
				nameEnum: "",
				formula: "",
				formulaOptions: "",
				firstNumber: "",
				minDigits: "",
				maxDigits: "",
				placeholder: "",
				labelTypeEntry: [],
				EnumTypeEntry: [],
				textEntry: [],
				formulaNameEntry: [],
				formulaOptionsEntry: "",
				formLabelEntry: [],
				formEnumEntry: [],
				formulaOptionsFormEntry: "",
				question: "",
				question2: "",
			});
			if (formData.type !== "label") {
				setOptionsLabel([]);
			}
			onClose();
		}
	};

	const toggleAccordion = (index) => {
		setFormEntries((entriess) => {
			const updatedEntries = entriess.map((entry, i) => {
				return {
					...entry,
					active: i === index ? !entry.active : entry.active,
				};
			});

			const allExpandedFunc = updatedEntries.every((entry) => {
				return entry.active;
			});
			const allCollapsed = updatedEntries.every((entry) => {
				return !entry.active;
			});

			if (allExpandedFunc) {
				setShowAllEntries(true);
			} else if (allCollapsed) {
				setShowAllEntries(false);
			}

			return updatedEntries;
		});
	};

	const hasError = (entry, name) => {
		const errorEntry = find(errors.errorList, {
			id: entry.id,
		});
		if (isEmpty(errorEntry)) {
			return "";
		}
		return get(errorEntry.errors, name, "");
	};

	const hasErrorEntryLabel = (entry, name, optionLabel) => {
		if (!optionLabel) return "";

		const errorEntry = find(errors.errorList, {
			id: entry.id,
		});
		if (isEmpty(errorEntry)) {
			return "";
		}
		const errorEntryLabel = find(errorEntry.optionsError, {
			id: optionLabel?.id,
		});

		if (isEmpty(errorEntryLabel)) {
			return "";
		}
		return get(errorEntryLabel.errors, name, "");
	};

	const hasTextErrorEntry = (entry, name, optionLabel) => {
		if (!optionLabel) return "";

		const errorEntry = find(errors.errorList, {
			id: entry.id,
		});
		if (isEmpty(errorEntry)) {
			return "";
		}
		const errorEntryLabel = find(errorEntry.optionsError, {
			id: optionLabel?.id,
		});

		if (isEmpty(errorEntryLabel)) {
			return "";
		}
		return get(errorEntryLabel.errors, name, "");
	};

	const hasNumebrErrorEntry = (entry, name, optionLabel) => {
		if (!optionLabel) return "";

		const errorEntry = find(errors.errorList, {
			id: entry.id,
		});
		if (isEmpty(errorEntry)) {
			return "";
		}
		const errorEntryLabel = find(errorEntry.optionsError, {
			id: optionLabel?.id,
		});

		if (isEmpty(errorEntryLabel)) {
			return "";
		}
		return get(errorEntryLabel.errors, name, "");
	};

	const hasLabelError = (optionsLabela, name) => {
		const errorLas = find(errors.errorLabel, {
			id: optionsLabela.id,
		});
		if (isEmpty(errorLas)) {
			return "";
		}
		return get(errorLas.errors, name, "");
	};

	const hasEnumError = (optionsLabela, name) => {
		const errorLas = find(errors.errorEnum, {
			id: optionsLabela.id,
		});
		if (isEmpty(errorLas)) {
			return "";
		}
		return get(errorLas.errors, name, "");
	};

	const hasFormulaError = (optionsLabela, name) => {
		const errorLas = find(errors.errorFormula, {
			id: optionsLabela.id,
		});
		if (isEmpty(errorLas)) {
			return "";
		}
		return get(errorLas.errors, name, "");
	};

	const hasTextError = (optionsLabela, name) => {
		const errorLas = find(errors.errorText, {
			id: optionsLabela.id,
		});
		if (isEmpty(errorLas)) {
			return "";
		}
		return get(errorLas.errors, name, "");
	};

	const hasNumberError = (optionsLabela, name) => {
		const errorLas = find(errors.errorNumber, {
			id: optionsLabela.id,
		});
		if (isEmpty(errorLas)) {
			return "";
		}
		return get(errorLas.errors, name, "");
	};

	const renderError = (errorEntry, entry) => {
		const mapEntry = map(errorEntry, (optionLabel) => {
			if (!optionLabel || !optionLabel.name) return null;

			return (
				<div>
					{optionLabel.name.length < 2 && (
						<div>
							{!isEmpty(hasErrorEntryLabel(entry, "labelTypeEntry", optionLabel)) && (
								<Label basic color="red" className={styles.errorLabel}>
									{isEmpty(optionLabel?.name)
										? hasErrorEntryLabel(entry, "labelTypeEntry", optionLabel)
										: "Nombre debe tener mínimo 2 caracteres"}
								</Label>
							)}
						</div>
					)}
				</div>
			);
		});
		return mapEntry;
	};

	const toggleAccordionLabel = (index) => {
		setOptionsLabel((optionss) => {
			return optionss.map((options, i) => {
				return {
					...options,
					active: i === index ? !options.active : options.active,
				};
			});
		});
	};

	const colorHandler = (index, value) => {
		let newValue = value;

		if (newValue.length === 6 && !newValue.startsWith("#")) {
			newValue = `#${newValue}`;
		}

		if (newValue.length <= 7) {
			setOptionsLabel((prevOptions) => {
				const updatedOptions = [...prevOptions];
				updatedOptions[index] = { ...updatedOptions[index], color: newValue };
				return updatedOptions;
			});
		}
	};

	const normalizeOptions = (raw = []) => {
		const nextId = 1;
		return raw.map((o) => {
			return {
				id: nextId + 1,
				name: (o?.name ?? "").trim(),
				color: o?.color ?? "",
				active: o?.active ?? false,
			};
		});
	};

	useEffect(() => {
		if (Array.isArray(formData?.options)) {
			setOptionsLabel(normalizeOptions(formData.options));
		} else {
			setOptionsLabel([]);
		}
	}, [formData?.options]);

	const addOption = () => {
		setOptionsLabel((prev) => {
			const nextId =
				Math.max(
					0,
					...prev.map((o) => {
						return Number(o.id) || 0;
					})
				) + 1;
			return [...prev, { id: nextId, name: "", color: "", active: true }];
		});
	};

	const addOptionFormula = () => {
		setOptionsLabel([...optionsLabel, { id: optionsLabel.length + 1, name: "", unit: "", active: true }]);
	};

	const addOptionEntry = (label, entry) => {
		const currentOptionLabel = get(entry, "options", []);
		updateItemData(label, [...currentOptionLabel, { id: currentOptionLabel.length + 1, name: "", color: "", active: true }], entry);
	};
	const addOptionStringEntry = (label, entry) => {
		const currentOptionLabel = get(entry, "options", []);
		updateItemData(label, [...currentOptionLabel, { id: currentOptionLabel.length + 1, name: "", active: true }], entry);
	};

	const addOptionFormulaEntry = (label, entry) => {
		const newId = getNewId(entry.options);
		const newOption = {
			id: newId,
			name: "",
			active: false,
		};
		entry.options.push(newOption);
		setFormData({ ...formData });
	};

	const addOptionNumberEntry = (label, entry) => {
		const newId = getNewId(entry.options);
		const newOption = {
			id: newId,
			name: "",
			active: true,
		};
		entry.options.push(newOption);
		setFormData({ ...formData });
	};

	const addOptionEnumEntry = (label, entry) => {
		const newId = getNewId(entry.options);
		const newOption = {
			id: newId,
			name: "",
			active: true,
		};
		entry.options = [...(entry.options || []), newOption];
		setFormData({ ...formData });
	};

	const addNameColorEntry = ({ label, entry, value, id }) => {
		const currentOptionLabel = get(entry, "options", []);
		const updatedOptions = currentOptionLabel.map((item) => {
			return item.id === id ? { ...item, [label]: value } : item;
		});

		updateItemData("options", updatedOptions, entry);
	};

	const addNumberEntry = ({ label, value, entry, id }) => {
		const currentOptionLabel = get(entry, "options", []);
		const updatedOptions = currentOptionLabel.map((item) => {
			return item.id === id ? { ...item, [label]: value } : item;
		});

		updateItemData("options", updatedOptions, entry);
	};

	const addStringEntry = ({ label, value, entry, id }) => {
		const currentOptionLabel = get(entry, "options", []);
		const updatedOptions = currentOptionLabel.map((item) => {
			return item.id === id ? { ...item, [label]: value } : item;
		});

		updateItemData("options", updatedOptions, entry);
	};

	const addEnumEntry = ({ label, value, entry, id }) => {
		const currentOptionLabel = get(entry, "options", []);
		const updatedOptions = currentOptionLabel.map((item) => {
			return item.id === id ? { ...item, [label]: value } : item;
		});

		updateItemData("options", updatedOptions, entry);
	};
	const addFormulaEntry = ({ label, entry, value, id }) => {
		const currentOptionLabel = get(entry, "options", []);
		const updatedOptions = currentOptionLabel.map((item) => {
			return item.id === id ? { ...item, [label]: value } : item;
		});

		updateItemData("options", updatedOptions, entry);
	};

	const updateItemData = (option, value, object) => {
		const arrayItems = formEntries.map((optionList) => {
			if (optionList.id === object.id) {
				const updatedEntry = { ...optionList, [option]: value };
				if (option === "type" && value !== "enum") {
					updatedEntry.options = "";
				}
				if (option === "type" && value !== "label") {
					updatedEntry.options = [];
				}
				if (option === "type" && value !== "formula") {
					updatedEntry.options = [];
				}
				return updatedEntry;
			}
			return optionList;
		});
		setFormEntries(arrayItems);
	};

	const reassignIds = (options) => {
		return options.map((item, index) => {
			return {
				...item,
				id: index + 1,
			};
		});
	};

	const rejectNameColorEntry = ({ id, entry }) => {
		if (!entry?.options?.length) return;

		const itemToDeleteEn = entry.options.find((item) => {
			return item.id === id;
		});

		if (isEmpty(itemToDeleteEn?.name)) {
			const updatedOptions = reject(entry.options, (item) => {
				return item.id === id;
			});
			const reorderedOptions = reassignIds(updatedOptions);

			updateItemData("options", reorderedOptions, entry);
			return;
		}

		setItemToDeleteLabelEntryAlert({ entry, id, name: itemToDeleteEn.name });
		setDeleteLabelEntryAlert(true);
	};

	const handleDeleteLabelEntryConfirm = () => {
		if (itemToDeleteLabelEntry) {
			const { entry, id } = itemToDeleteLabelEntry;
			const updatedOptions = reject(entry.options, (item) => {
				return item.id === id;
			});
			const reorderedOptions = reassignIds(updatedOptions);

			updateItemData("options", reorderedOptions, entry);
		}

		setDeleteLabelEntryAlert(false);
		setItemToDeleteLabelEntryAlert(null);
	};

	const rejectFormulaEntry = ({ id, entry }) => {
		if (!entry?.options?.length) return;

		const itemToDeleteEn = entry.options.find((item) => {
			return item.id === id;
		});

		if (isEmpty(itemToDeleteEn?.name)) {
			const updatedOptions = reject(entry.options, (item) => {
				return item.id === id;
			});
			const reorderedOptions = reassignIds(updatedOptions);

			updateItemData("options", reorderedOptions, entry);
			return;
		}

		setItemToDeleteFormulaEntryAlert({ entry, id, name: itemToDeleteEn.name });
		setDeleteFormulaEntryAlert(true);
	};

	const handleDeleteFormulaEntryConfirm = () => {
		if (itemToDeleteFormulaEntry) {
			const { entry, id } = itemToDeleteFormulaEntry;
			const updatedOptions = reject(entry.options, (item) => {
				return item.id === id;
			});
			const reorderedOptions = reassignIds(updatedOptions);

			updateItemData("options", reorderedOptions, entry);
		}

		setDeleteFormulaEntryAlert(false);
		setItemToDeleteFormulaEntryAlert(null);
	};

	const handleInputLabels = (index, field, value) => {
		setOptionsLabel((prevOptions) => {
			const updatedOptions = [...prevOptions];
			updatedOptions[index] = { ...updatedOptions[index], [field]: value };
			return updatedOptions;
		});
	};

	const removeOption = (e, option) => {
		e.stopPropagation();

		if (option.id !== null) {
			const isEmptyz = !option.name?.trim() && !option.color?.trim();

			if (isEmptyz) {
				setOptionsLabel((optionD) => {
					const filteredOptions = optionD.filter((opt) => {
						return opt.id !== option.id;
					});
					return reassignIds(filteredOptions);
				});
			} else {
				setItemToLabelDelete(option);
				setDeleteLabelAlert(true);
			}
		}
	};

	const removeOptionFormula = (e, option) => {
		e.stopPropagation();

		if (option.id !== null) {
			const isEmptyz = !trim(option.name) && !trim(option.unit);

			if (isEmptyz) {
				setOptionsLabel((optionD) => {
					const filteredOptions = filter(optionD, (opt) => {
						return opt.id !== option.id;
					});
					return reassignIds(filteredOptions);
				});
			} else {
				setItemToFormulaDelete(option);
				setDeleteFormulaAlert(true);
			}
		}
	};

	const handleDeleteLabelConfirm = () => {
		if (itemToLabelDelete) {
			setOptionsLabel((prevOptions) => {
				const filteredOptions = filter(prevOptions, (opt) => {
					return opt.id !== itemToLabelDelete.id;
				});
				return reassignIds(filteredOptions);
			});
		}
		setDeleteLabelAlert(false);
		setItemToLabelDelete(null);
	};

	const handleDeleteFormulaConfirm = () => {
		if (itemToFormulaDelete) {
			setOptionsLabel((prevOptions) => {
				const filteredOptions = filter(prevOptions, (opt) => {
					return opt.id !== itemToFormulaDelete.id;
				});
				return reassignIds(filteredOptions);
			});
		}
		setDeleteFormulaAlert(false);
		setItemToFormulaDelete(null);
	};

	const renderPopup = (label) => {
		return (
			<Popup
				content={<div className={styles.popoupClass}>{label}</div>}
				trigger={<span>{label.slice(0, 20)}...</span>}
				position="top center"
			/>
		);
	};

	const renderLabel = (label) => {
		return label.length > 30 ? renderPopup(label) : <span>{label}</span>;
	};

	const renderTableRow = (item, index, renderLabels) => {
		const [isOpen, setIsOpen] = useState(false);
		const isListType = item.type === "list";
		const entries = item.items || [];

		return (
			<>
				<tr key={index}>
					<td>{item.order}</td>
					<td>{renderLabels(item.label)}</td>
					{isListType && (
						<td>
							<Button
								className={styles.toggleButton}
								onClick={() => {
									return setIsOpen(!isOpen);
								}}>
								{isOpen ? "▲" : "▼"}
							</Button>
						</td>
					)}
				</tr>
				{isListType &&
					isOpen &&
					entries.map((entry, subIndex) => {
						return (
							<tr key={`${index}-${subIndex}`}>
								<td />
								<td className={styles.classTd}>
									→ {entry.order} {renderLabels(entry.label)}
								</td>
								<td />
							</tr>
						);
					})}
			</>
		);
	};

	const renderTableBody = (fields) => {
		return fields.length > 0 ? (
			map(fields, (item, index) => {
				return renderTableRow(item, index, renderLabel);
			})
		) : (
			<tr>
				<td colSpan="2">No hay datos disponibles</td>
			</tr>
		);
	};

	const handleToggleAllEntries = () => {
		const expandedCount = filter(formEntries, { active: true }).length;

		const newValue = expandedCount === 0;
		setShowAllEntries(newValue);

		const updated = map(formEntries, (entry) => {
			return {
				...entry,
				active: newValue,
			};
		});
		setFormEntries(updated);
	};

	useEffect(() => {
		if (formEntries.length === 0) return;
		const expandedCount = filter(formEntries, { active: true }).length;
		setShowAllEntries(expandedCount > 0);
	}, [formEntries]);

	const addMultipleOptions = () => {
		setOptionsLabel((prev) => {
			if (!prev || prev.length === 0) return prev;

			let activeIndex = prev.findIndex((o) => {
				return o.active;
			});
			if (activeIndex === -1) activeIndex = 0;

			const sourceText = (prev[activeIndex].name || "").trim();
			if (!sourceText) return prev;

			// Acepta: saltos de línea, comas, punto y coma, tabs, barra vertical
			const tokens = sourceText
				.split(/[\r\n,;|\t]+/)
				.map((t) => {
					return t.trim();
				})
				.filter(Boolean);

			if (tokens.length <= 1) return prev;

			const base = [...prev];
			base[activeIndex] = { ...base[activeIndex], name: tokens[0] };
			const nextId =
				Math.max(
					0,
					...base.map((o) => {
						return Number(o.id) || 0;
					})
				) + 1;
			// Evitar duplicados por nombre (case-insensitive)
			const existing = new Set(
				base.map((o) => {
					return (o.name || "").trim().toLowerCase();
				})
			);

			const toAdd = tokens.slice(1).reduce((acc, name) => {
				const key = name.toLowerCase();
				if (!existing.has(key)) {
					acc.push({ id: nextId + 1, name, color: "", active: false });
					existing.add(key);
				}
				return acc;
			}, []);

			return [...base, ...toAdd];
		});
	};

	const activeOption = find(optionsLabel, { active: true });

	// Función que cuenta cuántos "valores" hay en el texto
	const countTokens = (text = "") => {
		return size(
			compact(
				map(split(text, /[\r\n,;|\t]+/), (t) => {
					return t.trim();
				})
			)
		);
	};
	const addMultipleStringOptions = (label, entry) => {
		const options = get(entry, "options", []);
		const active = find(options, { active: true }) || options[0];

		const sourceText = (active?.name || "").trim();
		if (!sourceText) return;

		// separadores: salto de línea, coma, punto y coma, barra vertical, tab
		const rawTokens = sourceText
			.split(/\r?\n|,|;|\||\t/g)
			.map((t) => {
				return t.trim();
			})
			.filter(Boolean);

		if (rawTokens.length === 0) return;

		// evitar duplicados y opciones ya existentes (ignorando mayús/minús)
		const existingNames = new Set(
			options
				.filter((o) => {
					return Number(o?.id) !== Number(active?.id);
				})
				.map((o) => {
					return (o?.name || "").trim().toLowerCase();
				})
				.filter(Boolean)
		);

		const seen = new Set();
		const tokens = [];
		for (const t of rawTokens) {
			const key = t.toLowerCase();
			if (!seen.has(key) && !existingNames.has(key)) {
				seen.add(key);
				tokens.push(t);
			}
		}
		if (tokens.length === 0) return;

		const maxId = Math.max(
			0,
			...options.map((o) => {
				return Number(o?.id) || 0;
			})
		);

		const base = options
			.filter((o) => {
				return Number(o?.id) !== Number(active?.id);
			})
			.map((o) => {
				return { ...o, active: false };
			});

		// crea nuevas opciones; la primera queda activa
		const newOnes = tokens.map((name, idx) => {
			return {
				id: maxId + idx + 1,
				name,
				active: idx === 0,
			};
		});

		updateItemData(label, [...base, ...newOnes], entry);
	};

	const toggleAllAccordions = () => {
		setAllExpanded((prev) => {
			return !prev;
		});
		const updated = optionsLabel.map((opt) => {
			return {
				...opt,
				active: !allExpanded,
			};
		});
		setOptionsLabel(updated);
	};

	const toggleAllAccordionsEntries = (entry) => {
		const shouldActivateAll = !entry.options.every((o) => {
			return !!o.active;
		});
		const newOptions = entry.options.map((o) => {
			return {
				...o,
				active: shouldActivateAll,
			};
		});
		const updatedFormEntries = formEntries.map((it) => {
			return it.id === entry.id ? { ...it, options: newOptions } : it;
		});
		setFormEntries(updatedFormEntries);
	};

	return (
		<IKModal
			title={modalOption === "Add" ? "Agregar Registro" : `Registro: ${dataG.label} - Orden: ${dataG.order}`}
			mode={modalOption}
			noMode={modalOptionCompany === "Watch"}
			setMode={setModalOption}
			onClose={closeModal}
			onSuccess={save}
			size="small"
			fullHeight>
			<div className={styles.divContent}>
				<fieldset className={styles.fieldset2}>
					<Form noValidate>
						<Grid columns={2}>
							<Grid.Column width={8} className={styles.column}>
								<div className={styles.containerPfirst}>
									<div className={styles.fieldCheckBox}>
										<div className={styles.checkItem}>
											<span className={styles.label}>Perfil Visible:</span>
											<Checkbox
												toggle
												disabled={modalOption === "Watch"}
												label={formData.isVisible ? "Si" : "No"}
												name="isVisible"
												checked={formData.isVisible}
												onChange={handleCheckBox}
											/>
										</div>
										<div className={styles.checkItem}>
											<span className={styles.label}>Editable:</span>
											<Checkbox
												toggle
												disabled={modalOption === "Watch"}
												label={formData.isUpdateable ? "Si" : "No"}
												name="isUpdateable"
												checked={formData.isUpdateable}
												onChange={handleCheckBox}
											/>
										</div>
										<div className={styles.checkItem}>
											<span className={styles.label}>Requerido:</span>
											<Checkbox
												toggle
												disabled={modalOption === "Watch"}
												label={formData.isRequired ? "Si" : "No"}
												name="isRequired"
												checked={formData.isRequired}
												onChange={handleCheckBox}
											/>
										</div>
									</div>
								</div>
								<Divider />
								<div className={styles.inputContainer}>
									<div className={styles.inputGroupRow}>
										<div className={styles.classColumn}>
											<span className={styles.label}>Orden:</span>
											<Input
												value={String(formData.order)}
												disabled={modalOption !== "Edit"}
												icon="user"
												type="number"
												name="order"
												placeholder="Orden"
												fluid
												onChange={handleInput}
												className={styles.inputFieldOrdonIcono}
											/>
										</div>
										<div className={styles.classColumn}>
											<span className={styles.label}>Icono:</span>
											<Input
												value={String(formData.icon)}
												disabled={modalOption === "Watch"}
												icon="image"
												name="icon"
												placeholder="Icono"
												fluid
												onChange={handleInput}
											/>
										</div>
									</div>
								</div>

								<div className={styles.formContainer}>
									<div className={styles.inputGroupB}>
										<span className={styles.label}>
											Nombre: <span className={styles.required}>*</span>
										</span>
										<Input
											value={String(formData.label)}
											disabled={modalOption === "Watch"}
											name="label"
											icon="user"
											placeholder="Nombre del campo"
											error={!isEmpty(errors.label) && { content: errors.label, pointing: "above" }}
											onChange={handleInput}
											className={styles.inputField}
										/>
									</div>
									<div className={styles.inputGroupB}>
										<span className={styles.label}>PlaceHolder:</span>
										<Input
											value={String(formData.placeholder)}
											disabled={modalOption === "Watch"}
											name="placeholder"
											icon="barcode"
											placeholder="Placeholder del campo"
											onChange={handleInput}
											className={styles.inputField}
										/>
									</div>
									<div className={styles.inputGroupB}>
										<TextAreaInput
											label="Pregunta:"
											name="question"
											value={String(formData.question || "")}
											placeholder="Ej.: ¿Cuál es la capital de Francia?"
											onChange={handleInputQuestion}
											disabled={modalOption === "Watch"}
											minRows={1}
											maxRows={6}
											className={styles.inputField}
										/>
									</div>
									<div className={styles.containerType}>
										<div className={styles.inputGroupB}>
											<div className={styles.alignContent}>
												<div className={styles.columns2}>
													<span className={styles.label}>
														Tipo: <span className={styles.required}>*</span>
													</span>
													<Dropdown
														disabled={modalOption === "Watch"}
														required
														placeholder="Elegir Tipo"
														fluid
														clearable
														value={formData.type}
														name="type"
														additionPosition="top"
														search
														selection
														onChange={handleInputDropdown}
														options={typesData}
													/>
												</div>
												{formData.type === "list" && (
													<div className={styles.checkItem}>
														<span className={styles.label}>Multiple:</span>
														<Checkbox
															toggle
															disabled={modalOption === "Watch"}
															label={formData.isMultiple ? "Si" : "No"}
															name="isMultiple"
															checked={formData.isMultiple}
															onChange={handleCheckBox}
														/>
													</div>
												)}
												{formData.type === "group" && (
													<div className={styles.columns2}>
														<span className={styles.label}>
															SubTipo: <span className={styles.required}>*</span>
														</span>
														<Dropdown
															disabled={modalOption === "Watch"}
															required
															placeholder="Elegir SubTipo"
															fluid
															multiple
															clearable
															value={formData.options || []}
															name="options"
															additionPosition="top"
															search
															selection
															onChange={handleInputDropdown}
															options={[
																{ key: "Sucursal", value: "Sucursal", text: "Sucursal" },
																{ key: "Departamento", value: "Departamento", text: "Departamento" },
																{ key: "Telefono", value: "Telefono", text: "Teléfono" },
															]}
														/>
													</div>
												)}
											</div>
											{!isEmpty(errors.type) && (
												<Label basic color="red" className={styles.errorLabel}>
													{errors.type}
												</Label>
											)}
										</div>
									</div>
								</div>
								{formData.type === "number" && (
									<div className={styles.inputGroupB}>
										<span className={styles.label}>Cantidad de Dígitos:</span>
										<div className={styles.doubleInputWrapper}>
											<Input
												value={String(formData.minDigits || "")}
												disabled={modalOption === "Watch"}
												icon="slack hash"
												name="minDigits"
												type="number"
												placeholder="Mínimo"
												fluid
												onChange={handleInput}
												min="1"
												className={styles.inputFieldN}
												// error={!isEmpty(errors.minDigits) && { content: errors.minDigits, pointing: "above" }}
											/>
											<Input
												value={String(formData.maxDigits || "")}
												disabled={modalOption === "Watch"}
												icon="slack hash"
												name="maxDigits"
												type="number"
												placeholder="Máximo"
												fluid
												onChange={handleInput}
												min="1"
												className={styles.inputFieldN}
												// error={!isEmpty(errors.maxDigits) && { content: errors.maxDigits, pointing: "above" }}
											/>
										</div>
									</div>
								)}

								{formData.type === "password" && (
									<div className={styles.inputGroupB}>
										<span className={styles.label}>Cantidad de Dígitos:</span>
										<div className={styles.doubleInputWrapper}>
											<Input
												value={String(formData.minDigits || "")}
												disabled={modalOption === "Watch"}
												icon="slack hash"
												name="minDigits"
												type="number"
												placeholder="Mínimo"
												fluid
												onChange={handleInput}
												min="1"
												className={styles.inputFieldN}
												// error={!isEmpty(errors.minDigits) && { content: errors.minDigits, pointing: "above" }}
											/>
											<Input
												value={String(formData.maxDigits || "")}
												disabled={modalOption === "Watch"}
												icon="slack hash"
												name="maxDigits"
												type="number"
												placeholder="Máximo"
												fluid
												onChange={handleInput}
												min="1"
												className={styles.inputFieldN}
												// error={!isEmpty(errors.maxDigits) && { content: errors.maxDigits, pointing: "above" }}
											/>
										</div>
									</div>
								)}
								{formData.type === "formula" && (
									<div className={styles.inputGroupB}>
										<TextAreaInput
											label="Fórmula:"
											name="formula"
											value={String(formData.formula || "")}
											placeholder="Ej.: E = m·c²"
											onChange={(e) => {
												return handleInput(e, { name: "formula", value: e.target.value });
											}}
											disabled={modalOption === "Watch"}
											minRows={1}
											maxRows={6}
											showRequired
											className={styles.inputField}
										/>
										{!isEmpty(errors.formula) && (
											<Label basic color="red" className={styles.errorLabel}>
												{errors.formula}
											</Label>
										)}
									</div>
								)}
							</Grid.Column>

							<Grid.Column width={8} className={styles.gridColumn}>
								{formData.type === "list" ? (
									<div className={styles.fixedContainer}>
										<div className={styles.scrollableTable}>
											<fieldset className={styles.fieldset2}>
												<legend className={styles.legend}>Registros de Información:</legend>
												<div className={styles.resumenGroup}>
													<div className={styles.tableContainer}>
														<table className={styles.tableResumen}>
															<tbody>{renderTableBody(filteredCompanyFields)}</tbody>
														</table>
													</div>
												</div>
											</fieldset>
										</div>

										<div className={styles.fixedBottomInputs}>
											<div className={styles.inputGroupB}>
												<TextAreaInput
													label="Question:"
													name="question2"
													value={String(formData.question2 || "")}
													placeholder="Eg. What is the capital of Italy?"
													onChange={handleInputQuestion}
													disabled={modalOption === "Watch"}
													minRows={1}
													maxRows={6}
													className={styles.inputField}
												/>
											</div>

											<div className={styles.checkItem2}>
												<span className={styles.label}>Abierta:</span>
												<Checkbox
													toggle
													disabled={modalOption === "Watch"}
													label={formData.isOpen ? "Si" : "No"}
													name="isOpen"
													checked={formData.isOpen}
													onChange={handleCheckBox}
												/>
											</div>
										</div>
									</div>
								) : (
									<>
										<fieldset className={styles.fieldset2}>
											<legend className={styles.legend}>Registros de Información:</legend>
											<div className={styles.resumenGroup}>
												<div className={styles.tableContainer}>
													<table className={styles.tableResumen}>
														<tbody>{renderTableBody(filteredCompanyFields)}</tbody>
													</table>
												</div>
											</div>
										</fieldset>

										<div className={styles.inputGroupBP}>
											<TextAreaInput
												label="Pregunta:"
												name="question2"
												value={String(formData.question2 || "")}
												placeholder="Eg. What is the capital of Italy?"
												onChange={handleInputQuestion}
												disabled={modalOption === "Watch"}
												minRows={1}
												maxRows={6}
												className={styles.inputField}
											/>
										</div>
									</>
								)}
							</Grid.Column>

							{formData.type === "string" && (
								<Accordion fluid>
									<fieldset className={styles.card}>
										<legend className={styles.legend}>
											<div className={styles.containerOptionss}>
												Opciones
												{/* <div className={styles.flexEnd} role="button" tabIndex={0} onClick={toggleAllAccordions}>
													<Icon name={allExpanded ? "chevron down" : "chevron up"} className={styles.chevronIconPre} />
													<Text className={styles.textToggle} disabled={modalOption === "Watch"}>
														{allExpanded ? "Colapsar Todas" : "Expandir Todas"}
													</Text>
												</div> */}
											</div>
										</legend>

										{optionsLabel.length > 0 &&
											optionsLabel.map((optionLabel, index) => {
												return (
													<Card key={optionLabel.id} className={styles.fieldset}>
														<Accordion.Title
															active={optionLabel.active}
															index={index}
															onClick={() => {
																return toggleAccordionLabel(index);
															}}
															className={styles.accordionTitle}>
															<div className={styles.divTitleString}>
																<Icon
																	name="trash"
																	negative
																	onClick={(e) => {
																		return removeOption(e, optionLabel);
																	}}
																	disabled={modalOption === "Watch"}
																	className={styles.removeItemButton}
																/>
																<div className={styles.boltClass}>
																	<Icon name="dropdown" />
																	{index + 1}.{optionLabel.name}
																</div>
															</div>
															{optionLabel.name.length < 2 && (
																<div>
																	{!isEmpty(hasTextError(optionLabel, "nameText")) && isEmpty(optionLabel.name) && (
																		<Label basic color="red" className={styles.errorLabel}>
																			{hasTextError(optionLabel, "nameText")}
																		</Label>
																	)}
																	{!isEmpty(hasTextError(optionLabel, "nameText")) && !isEmpty(optionLabel.name) && (
																		<Label basic color="red" className={styles.errorLabel}>
																			Nombre debe tener mínimo 2 caracteres
																		</Label>
																	)}
																</div>
															)}
														</Accordion.Title>

														<Accordion.Content active={optionLabel.active}>
															<Form noValidate>
																<Grid columns={1}>
																	<Grid.Column width={16}>
																		<div className={styles.container}>
																			<div className={styles.halfWidthString}>
																				<TextAreaInput
																					placeholder="Eg. Juan Pérez"
																					name="nameLabel"
																					required
																					value={optionLabel.name}
																					onChange={(e) => {
																						return handleInputLabels(index, "name", e.target.value);
																					}}
																					disabled={modalOption === "Watch"}
																					label="Nombre:"
																					minRows={1}
																					maxRows={6}
																					showRequired
																					className={styles.inputField}
																				/>
																			</div>
																		</div>
																	</Grid.Column>
																</Grid>
															</Form>
														</Accordion.Content>
													</Card>
												);
											})}

										<div className={styles.divButtons}>
											<Button type="button" onClick={addOptionFormula} className={styles.butttonAdd} disabled={modalOption === "Watch"}>
												<Icon name="plus" /> Agregar opción
											</Button>
											{/* <Button
												type="button"
												onClick={addMultipleOptions}
												className={styles.butttonAdd}
												disabled={countTokens(activeOption?.name) < 2 || modalOption === "Watch"}>
												Multiples
											</Button> */}
										</div>
									</fieldset>
								</Accordion>
							)}

							{formData.type === "number" && (
								<Accordion fluid>
									<fieldset className={styles.card}>
										<legend className={styles.legend}>Opciones</legend>
										{optionsLabel.length > 0 &&
											optionsLabel.map((optionLabel, index) => {
												return (
													<Card key={optionLabel.id} className={styles.fieldset}>
														<Accordion.Title
															active={optionLabel.active}
															index={index}
															onClick={() => {
																return toggleAccordionLabel(index);
															}}
															className={styles.accordionTitle}>
															<div className={styles.divTitle}>
																<Icon
																	name="trash"
																	negative
																	onClick={(e) => {
																		return removeOption(e, optionLabel);
																	}}
																	disabled={modalOption === "Watch"}
																	className={styles.removeItemButton}
																/>
																<div className={styles.boltClass}>
																	<Icon name="dropdown" />
																	{index + 1}.{optionLabel.name}
																</div>
															</div>

															{optionLabel.name.length < 2 && (
																<div>
																	{!isEmpty(hasNumberError(optionLabel, "nameNumber")) && isEmpty(optionLabel.name) && (
																		<Label basic color="red" className={styles.errorLabel}>
																			{hasNumberError(optionLabel, "nameNumber")}
																		</Label>
																	)}

																	{!isEmpty(hasNumberError(optionLabel, "nameNumber")) && !isEmpty(optionLabel.name) && (
																		<Label basic color="red" className={styles.errorLabel}>
																			Nombre debe tener mínimo 2 caracteres
																		</Label>
																	)}
																</div>
															)}
														</Accordion.Title>

														<Accordion.Content active={optionLabel.active}>
															<Form noValidate>
																<Grid columns={1}>
																	<Grid.Column width={16}>
																		<div className={styles.container}>
																			<div className={styles.halfWidth}>
																				<span className={styles.label}>
																					Nombre: <span className={styles.required}>*</span>
																				</span>
																				<Input
																					type="text"
																					placeholder="Nombre"
																					name="nameLabel"
																					required
																					value={optionLabel.name}
																					onChange={(e) => {
																						return handleInputLabels(index, "name", e.target.value);
																					}}
																					disabled={modalOption === "Watch"}
																					fluid
																				/>
																			</div>
																		</div>
																	</Grid.Column>
																</Grid>
															</Form>
														</Accordion.Content>
													</Card>
												);
											})}
										<Button type="button" onClick={addOptionFormula} className={styles.butttonAdd} disabled={modalOption === "Watch"}>
											<Icon name="plus" /> Agregar opción
										</Button>
									</fieldset>
								</Accordion>
							)}

							{formData.type === "formula" && (
								<Accordion fluid>
									<fieldset className={styles.card}>
										<legend className={styles.legend}>Opciones</legend>
										{optionsLabel.length > 0 &&
											optionsLabel.map((optionLabel, index) => {
												return (
													<Card key={optionLabel.id} className={styles.fieldset}>
														<Accordion.Title
															active={optionLabel.active}
															index={index}
															onClick={() => {
																return toggleAccordionLabel(index);
															}}
															className={styles.accordionTitle}>
															<div className={styles.divTitle}>
																<Icon
																	name="trash"
																	negative
																	onClick={(e) => {
																		return removeOptionFormula(e, optionLabel);
																	}}
																	disabled={modalOption === "Watch"}
																	className={styles.removeItemButton}
																/>
																<div className={styles.boltClass}>
																	<Icon name="dropdown" />
																	{index + 1}.{optionLabel.name}
																</div>
															</div>

															{optionLabel.name.length < 2 && (
																<div>
																	{!isEmpty(hasFormulaError(optionLabel, "nameFormula")) && isEmpty(optionLabel.name) && (
																		<Label basic color="red" className={styles.errorLabel}>
																			{hasFormulaError(optionLabel, "nameFormula")}
																		</Label>
																	)}
																</div>
															)}
														</Accordion.Title>

														<Accordion.Content active={optionLabel.active}>
															<Form noValidate>
																<Grid columns={1}>
																	<Grid.Column width={16}>
																		<div className={styles.container}>
																			<div className={styles.halfWidth}>
																				<span className={styles.label}>
																					Nombre: <span className={styles.required}>*</span>
																				</span>
																				<Input
																					type="text"
																					placeholder="Nombre"
																					name="nameLabel"
																					required
																					value={optionLabel.name}
																					onChange={(e) => {
																						return handleInputLabels(index, "name", e.target.value);
																					}}
																					disabled={modalOption === "Watch"}
																					// error={!isEmpty(errors.formulaOptions) && { content: errors.formulaOptions, pointing: "above" }}
																					fluid
																				/>
																			</div>

																			<div className={styles.halfWidth}>
																				<span className={styles.label}>Unidad:</span>
																				<Input
																					type="text"
																					placeholder="Ej: Lb, Kg, m2"
																					name="unit"
																					value={optionLabel.unit || ""}
																					onChange={(e) => {
																						return handleInputLabels(index, "unit", e.target.value);
																					}}
																					disabled={modalOption === "Watch"}
																					fluid
																				/>
																			</div>
																		</div>
																	</Grid.Column>
																</Grid>
															</Form>
														</Accordion.Content>
													</Card>
												);
											})}
										<Button type="button" onClick={addOptionFormula} className={styles.butttonAdd} disabled={modalOption === "Watch"}>
											<Icon name="plus" /> Agregar opción
										</Button>
									</fieldset>
								</Accordion>
							)}

							{formData.type === "enum" && (
								<Accordion fluid>
									<fieldset className={styles.card}>
										<legend className={styles.legend}>
											<div className={styles.containerOptionss}>
												Opciones
												<div className={styles.flexEnd} role="button" tabIndex={0} onClick={toggleAllAccordions}>
													<Icon name={allExpanded ? "chevron down" : "chevron up"} className={styles.chevronIconPre} />
													<Text className={styles.textToggle} disabled={modalOption === "Watch"}>
														{allExpanded ? "Colapsar Todas" : "Expandir Todas"}
													</Text>
												</div>
											</div>
										</legend>
										{optionsLabel.length > 0 &&
											formData.type === "enum" &&
											optionsLabel.map((optionLabel, index) => {
												return (
													<Card key={optionLabel.id} className={styles.fieldset}>
														<Accordion.Title
															active={optionLabel.active}
															index={index}
															onClick={() => {
																return toggleAccordionLabel(index);
															}}
															className={styles.accordionTitle}>
															<div className={styles.divTitle}>
																<Icon
																	name="trash"
																	negative
																	onClick={(e) => {
																		return removeOption(e, optionLabel);
																	}}
																	disabled={modalOption === "Watch"}
																	className={styles.removeItemButton}
																/>
																<div className={styles.boltClass}>
																	<Icon name="dropdown" />
																	{index + 1}.{optionLabel.name}
																</div>
															</div>
															{optionLabel.name.length < 2 && (
																<div>
																	{!isEmpty(hasEnumError(optionLabel, "nameEnum")) && isEmpty(optionLabel.name) && (
																		<Label basic color="red" className={styles.errorLabel}>
																			{hasEnumError(optionLabel, "nameEnum")}
																		</Label>
																	)}

																	{!isEmpty(hasEnumError(optionLabel, "nameEnum")) && !isEmpty(optionLabel.name) && (
																		<Label basic color="red" className={styles.errorLabel}>
																			Nombre debe tener mínimo 2 caracteres
																		</Label>
																	)}
																</div>
															)}
														</Accordion.Title>
														<Accordion.Content active={optionLabel.active}>
															<Form noValidate>
																<Grid columns={1}>
																	<Grid.Column width={16}>
																		<div className={styles.container}>
																			<div className={styles.halfWidth}>
																				<TextAreaInput
																					label="Nombre:"
																					name="nameEnum"
																					value={optionLabel.name}
																					placeholder="Ej.: Juan Pérez"
																					onChange={(e) => {
																						return handleInputLabels(index, "name", e.target.value);
																					}}
																					disabled={modalOption === "Watch"}
																					minRows={1}
																					maxRows={6}
																					showRequired
																					className={styles.inputField}
																				/>
																			</div>
																		</div>
																	</Grid.Column>
																</Grid>
															</Form>
														</Accordion.Content>
													</Card>
												);
											})}
										<div className={styles.divButtons}>
											<Button type="button" onClick={addOption} className={styles.butttonAdd} disabled={modalOption === "Watch"}>
												<Icon name="plus" /> Agregar opción
											</Button>
											<Button
												type="button"
												onClick={addMultipleOptions}
												className={styles.butttonAdd}
												disabled={countTokens(activeOption?.name) < 2 || modalOption === "Watch"}>
												Multiples
											</Button>
										</div>
									</fieldset>
									{!isEmpty(errors.formEnum) && (
										<Label basic color="red" className={styles.errorLabel}>
											{errors.formEnum}
										</Label>
									)}
								</Accordion>
							)}

							{formData.type === "label" && (
								<Accordion fluid>
									<fieldset className={styles.card}>
										<legend className={styles.legend}>Opciones</legend>
										{optionsLabel.length > 0 &&
											formData.type === "label" &&
											optionsLabel.map((optionLabel, index) => {
												return (
													<Card key={optionLabel.id} className={styles.fieldset}>
														<Accordion.Title
															active={optionLabel.active}
															index={index}
															onClick={() => {
																return toggleAccordionLabel(index);
															}}
															className={styles.accordionTitle}>
															<div className={styles.divTitle}>
																<Icon
																	name="trash"
																	negative
																	onClick={(e) => {
																		return removeOption(e, optionLabel);
																	}}
																	disabled={modalOption === "Watch"}
																	className={styles.removeItemButton}
																/>
																<div className={styles.boltClass}>
																	<Icon name="dropdown" />
																	{index + 1}.{optionLabel.name}
																</div>
															</div>
															{optionLabel.name.length < 2 && (
																<div>
																	{!isEmpty(hasLabelError(optionLabel, "nameLabel")) && isEmpty(optionLabel.name) && (
																		<Label basic color="red" className={styles.errorLabel}>
																			{hasLabelError(optionLabel, "nameLabel")}
																		</Label>
																	)}

																	{!isEmpty(hasLabelError(optionLabel, "nameLabel")) && !isEmpty(optionLabel.name) && (
																		<Label basic color="red" className={styles.errorLabel}>
																			Nombre debe tener mínimo 2 caracteres
																		</Label>
																	)}
																</div>
															)}
														</Accordion.Title>
														<Accordion.Content active={optionLabel.active}>
															<Form noValidate>
																<Grid columns={1}>
																	<Grid.Column width={16}>
																		<div className={styles.container}>
																			<div className={styles.halfWidth}>
																				<TextAreaInput
																					label="Nombre:"
																					name="nameLabel"
																					value={String(optionLabel.name || "")}
																					placeholder="Ej.: Juan Pérez"
																					onChange={(e) => {
																						return handleInputLabels(index, "name", e.target.value);
																					}}
																					disabled={modalOption === "Watch"}
																					minRows={1}
																					maxRows={6}
																					showRequired
																					className={styles.inputField}
																				/>
																				{optionLabel.name.length < 2 && (
																					<div>
																						{!isEmpty(hasLabelError(optionLabel, "nameLabel")) && isEmpty(optionLabel.name) && (
																							<Label basic color="red" className={styles.errorLabel}>
																								{hasLabelError(optionLabel, "nameLabel")}
																							</Label>
																						)}

																						{!isEmpty(hasLabelError(optionLabel, "nameLabel")) && !isEmpty(optionLabel.name) && (
																							<Label basic color="red" className={styles.errorLabel}>
																								Nombre debe tener mínimo 2 caracteres
																							</Label>
																						)}
																					</div>
																				)}
																			</div>

																			<div className={styles.halfWidth2}>
																				<ColorPickerDropdown
																					currentColor={optionLabel.color}
																					setCurrentColor={(value) => {
																						return colorHandler(index, value);
																					}}
																					disabled={modalOption === "Watch"}
																					// className={styles.pickerr}
																				/>
																			</div>
																		</div>
																	</Grid.Column>
																</Grid>
															</Form>
														</Accordion.Content>
													</Card>
												);
											})}
										<Button type="button" onClick={addOption} className={styles.butttonAdd} disabled={modalOption === "Watch"}>
											<Icon name="plus" /> Agregar opción
										</Button>
									</fieldset>
									{!isEmpty(errors.formLabel) && (
										<Label basic color="red" className={styles.errorLabel}>
											{errors.formLabel}
										</Label>
									)}
								</Accordion>
							)}
						</Grid>
					</Form>
					{isList && (
						<Accordion fluid>
							<fieldset className={styles.card}>
								<legend className={styles.legendS}>
									<span>Lista del Registro de Información</span>
									<div
										className={`${styles.flexEnd} ${formEntries.length === 0 ? styles.disabled : ""}`}
										role="button"
										tabIndex={formEntries.length === 0 ? -1 : 0}
										onClick={formEntries.length === 0 ? undefined : handleToggleAllEntries}
										disabled={modalOption === "Watch"}>
										<Icon name={showAllEntries ? "chevron down" : "chevron up"} className={styles.chevronIconPre} />
										<Text className={styles.textToggle} disabled={modalOption === "Watch"}>
											{showAllEntries ? "Colapsar Todas" : "Expandir Todas"}
										</Text>
									</div>
								</legend>

								{formEntries.length > 0 &&
									isList &&
									formEntries.map((entry, index) => {
										return (
											<Card key={entry.id} className={styles.fieldset}>
												<Accordion.Title
													active={entry.active}
													index={index}
													onClick={() => {
														return toggleAccordion(index);
													}}
													className={styles.accordionTitle}>
													<div className={styles.divTitle}>
														<Icon
															name="trash"
															negative
															onClick={(e) => {
																return handleDeleteRequest(e, entry, [
																	"label",
																	"type",
																	"isVisible",
																	"isUpdateable",
																	"isRequired",
																	"placeholder",
																	"order",
																	"icon",
																]);
															}}
															disabled={modalOption === "Watch"}
															className={styles.removeItemButton}
														/>
														<div className={styles.boltClass}>
															<Icon name="dropdown" />
															{index + 1}.{entry.label}
														</div>
													</div>
													<div className={styles.containerError}>
														{entry.label.length < 2 && (
															<div>
																{!isEmpty(hasError(entry, "entriesLabel")) && isEmpty(entry.label) && (
																	<Label basic color="red" className={styles.errorLabel}>
																		{hasError(entry, "entriesLabel")}
																	</Label>
																)}

																{!isEmpty(hasError(entry, "entriesLabel")) && !isEmpty(entry.label) && (
																	<Label basic color="red" className={styles.errorLabel}>
																		Nombre debe tener mínimo 2 caracteres
																	</Label>
																)}
															</div>
														)}
														{renderError(entry.options, entry)}
														{!isEmpty(hasError(entry, "formLabelEntry")) && (
															<Label basic color="red" className={styles.errorLabel}>
																{hasError(entry, "formLabelEntry")}
															</Label>
														)}
														{!isEmpty(hasError(entry, "formEnumEntry")) && (
															<Label basic color="red" className={styles.errorLabel}>
																{hasError(entry, "formEnumEntry")}
															</Label>
														)}
														{/*  */}
														{
															// !isEmpty(hasError(entry, "number")) ||
															// !isEmpty(hasError(entry, "password")) ||
															// !isEmpty(hasError(entry, "entriesLabel")) ||
															!isEmpty(hasError(entry, "typeEntries")) && (
																<Label basic color="red" className={styles.errorLabel}>
																	{
																		// hasError(entry, "number") ||
																		// hasError(entry, "password") ||
																		// hasError(entry, "entriesLabel") ||
																		hasError(entry, "typeEntries")
																	}
																</Label>
															)
														}
													</div>
												</Accordion.Title>
												<Accordion.Content active={entry.active}>
													<Form noValidate>
														{/* <Divider /> */}
														<Grid columns={1}>
															<Grid.Column width={16} className={styles.column}>
																<div className={styles.containerPfirst2}>
																	<div className={styles.fieldCheckBox}>
																		<div className={styles.checkItem}>
																			<span className={styles.label}>Perfil Visible:</span>
																			<Checkbox
																				toggle
																				label={entry.isVisible ? "Si" : "no"}
																				checked={entry.isVisible}
																				onChange={(e, { checked }) => {
																					return updateItemData("isVisible", checked, entry);
																				}}
																				disabled={modalOption === "Watch"}
																			/>
																		</div>
																		<div className={styles.checkItem}>
																			<span className={styles.label}>Editable:</span>
																			<Checkbox
																				toggle
																				label={entry.isUpdateable ? "Si" : "No"}
																				checked={entry.isUpdateable}
																				onChange={(e, { checked }) => {
																					return updateItemData("isUpdateable", checked, entry);
																				}}
																				disabled={modalOption === "Watch"}
																			/>
																		</div>
																		<div className={styles.checkItem}>
																			<span className={styles.label}>Requerido:</span>
																			<Checkbox
																				toggle
																				label={entry.isRequired ? "Si" : "No"}
																				checked={entry.isRequired}
																				onChange={(e, { checked }) => {
																					return updateItemData("isRequired", checked, entry);
																				}}
																				disabled={modalOption === "Watch"}
																			/>
																		</div>
																	</div>
																</div>

																<Divider />

																<div className={styles.inputContainer}>
																	<div className={styles.inputGroupRow2}>
																		<div className={styles.classColumn}>
																			<span className={styles.label}>Orden:</span>
																			<Input
																				value={String(entry.order)}
																				icon="user"
																				type="number"
																				placeholder="Orden"
																				fluid
																				onChange={(e, { value }) => {
																					return updateItemData("order", value, entry);
																				}}
																				className={styles.inputName}
																				disabled={modalOption !== "Edit"}
																			/>
																		</div>
																		<div className={styles.classColumn}>
																			<span className={styles.label}>Icono:</span>
																			<Input
																				value={String(entry.icon)}
																				icon="image"
																				placeholder="Icono:"
																				fluid
																				onChange={(e, { value }) => {
																					return updateItemData("icon", value, entry);
																				}}
																				disabled={modalOption === "Watch"}
																			/>
																		</div>
																	</div>
																</div>

																<div className={styles.formContainer2}>
																	<div className={styles.inputGroupB}>
																		<span className={styles.label}>
																			Nombre: <span className={styles.required}>*</span>
																		</span>
																		<Input
																			value={String(entry.label)}
																			icon="user"
																			// label="Nombre:"
																			placeholder="Nombre del campo"
																			disabled={modalOption === "Watch"}
																			required
																			fluid
																			onChange={(e, { value }) => {
																				return updateItemData("label", value, entry);
																			}}
																		/>
																		{/* {entry.label.length < 2 && (
																			<div>
																				{!isEmpty(hasError(entry, "entriesLabel")) && isEmpty(entry.label) && (
																					<Label basic color="red" className={styles.errorLabel}>
																						{hasError(entry, "entriesLabel")}
																					</Label>
																				)}

																				{!isEmpty(hasError(entry, "entriesLabel")) && !isEmpty(entry.label) && (
																					<Label basic color="red" className={styles.errorLabel}>
																						Nombre debe tener mínimo 2 caracteres
																					</Label>
																				)}
																			</div>
																		)} */}
																	</div>
																	<div className={styles.inputGroupB}>
																		<span className={styles.label}>PlaceHolder:</span>
																		<Input
																			value={String(entry.placeholder)}
																			disabled={modalOption === "Watch"}
																			icon="barcode"
																			placeholder="Placeholder del campo"
																			onChange={(e, { value }) => {
																				return updateItemData("placeholder", value, entry);
																			}}
																			className={styles.inputField}
																		/>
																	</div>
																	<div className={styles.inputGroupB}>
																		<TextAreaInput
																			label="Pregunta:"
																			name="question"
																			value={String(entry.question || "")}
																			placeholder="Ej.: ¿Cuál es el resultado de 2 + 2?"
																			onChange={(e) => {
																				return updateItemData("question", e.target.value, entry);
																			}}
																			disabled={modalOption === "Watch"}
																			minRows={1}
																			maxRows={6}
																			className={styles.inputField}
																		/>
																	</div>
																	<div className={styles.inputGroupB}>
																		<TextAreaInput
																			label="Question:"
																			name="question2"
																			value={String(entry.question2 || "")}
																			placeholder="Eg. What is the square root of 16?"
																			onChange={(e) => {
																				return updateItemData("question2", e.target.value, entry);
																			}}
																			disabled={modalOption === "Watch"}
																			minRows={1}
																			maxRows={6}
																			className={styles.inputField}
																		/>
																	</div>

																	<div className={styles.inputGroupB}>
																		<div className={styles.alignContent}>
																			<div className={styles.columns2}>
																				<span className={styles.label}>
																					Tipo: <span className={styles.required}>*</span>
																				</span>
																				<Dropdown
																					required
																					placeholder="Elegir Tipo"
																					fluid
																					clearable
																					value={entry.type}
																					additionPosition="top"
																					disabled={modalOption === "Watch"}
																					search
																					selection
																					onChange={(e, { value }) => {
																						return updateItemData("type", value, entry);
																					}}
																					options={typseDataBorn}
																				/>
																			</div>
																			{entry.type === "enum" && (
																				<div className={styles.checkItem}>
																					<span className={styles.label}>Multiple:</span>
																					<Checkbox
																						toggle
																						disabled={modalOption === "Watch"}
																						label={entry.isMultiple ? "Si" : "No"}
																						name="isMultiple"
																						checked={entry.isMultiple}
																						onChange={(e, { checked }) => {
																							return updateItemData("isMultiple", checked, entry);
																						}}
																					/>
																				</div>
																			)}
																			{entry.type === "group" && (
																				<div className={styles.columns2}>
																					<span className={styles.label}>
																						SubTipo: <span className={styles.required}>*</span>
																					</span>
																					<Dropdown
																						disabled={modalOption === "Watch"}
																						required
																						placeholder="Elegir SubTipo"
																						fluid
																						multiple
																						clearable
																						value={entry.options || []}
																						additionPosition="top"
																						search
																						selection
																						onChange={(e, { value }) => {
																							return updateItemData("options", value, entry);
																						}}
																						options={[
																							{ key: "Sucursal", value: "Sucursal", text: "Sucursal" },
																							{ key: "Departamento", value: "Departamento", text: "Departamento" },
																							{ key: "Telefono", value: "Telefono", text: "Teléfono" },
																						]}
																					/>
																				</div>
																			)}
																		</div>
																	</div>
																</div>

																{entry.type === "number" && (
																	<div className={styles.inputGroupB}>
																		<span className={styles.label}>Cantidad de Dígitos:</span>
																		<div className={styles.doubleInputWrapper}>
																			<Input
																				value={String(entry.minDigits || "")}
																				disabled={modalOption === "Watch"}
																				icon="slack hash"
																				name="minDigits"
																				type="number"
																				placeholder="Mínimo"
																				fluid
																				onChange={(e, { value }) => {
																					const numericValue = parseInt(value, 10);
																					if (numericValue >= 1 || value === "") {
																						updateItemData("minDigits", value, entry);
																					}
																				}}
																				min="1"
																				className={styles.inputFieldN}
																			/>

																			<Input
																				value={String(entry.maxDigits || "")}
																				disabled={modalOption === "Watch"}
																				icon="slack hash"
																				name="maxDigits"
																				type="number"
																				placeholder="Máximo"
																				fluid
																				onChange={(e, { value }) => {
																					const numericValue = parseInt(value, 10);
																					if (numericValue >= 1 || value === "") {
																						updateItemData("maxDigits", value, entry);
																					}
																				}}
																				min="1"
																				className={styles.inputFieldN}
																			/>
																		</div>
																	</div>
																)}
																{entry.type === "password" && (
																	<div className={styles.inputGroupB}>
																		<span className={styles.label}>Cantidad de Dígitos:</span>
																		<div className={styles.doubleInputWrapper}>
																			<Input
																				value={String(entry.minDigits || "")}
																				disabled={modalOption === "Watch"}
																				icon="slack hash"
																				name="minDigits"
																				type="number"
																				placeholder="Mínimo"
																				fluid
																				onChange={(e, { value }) => {
																					const numericValue = parseInt(value, 10);
																					if (numericValue >= 1 || value === "") {
																						updateItemData("minDigits", value, entry);
																					}
																				}}
																				min="1"
																				className={styles.inputFieldN}
																			/>

																			<Input
																				value={String(entry.maxDigits || "")}
																				disabled={modalOption === "Watch"}
																				icon="slack hash"
																				name="maxDigits"
																				type="number"
																				placeholder="Máximo"
																				fluid
																				onChange={(e, { value }) => {
																					const numericValue = parseInt(value, 10);
																					if (numericValue >= 1 || value === "") {
																						updateItemData("maxDigits", value, entry);
																					}
																				}}
																				min="1"
																				className={styles.inputFieldN}
																			/>
																		</div>
																	</div>
																)}
																{entry.type === "formula" && (
																	<div className={styles.inputGroupB}>
																		<TextAreaInput
																			label="Fórmula:"
																			name="formula"
																			value={String(entry.formula || "")}
																			placeholder="Ej.: E = m·c²"
																			onChange={(e) => {
																				return updateItemData("formula", e.target.value, entry);
																			}}
																			disabled={modalOption === "Watch"}
																			minRows={1}
																			maxRows={6}
																			showRequired
																			className={styles.inputFieldFomrul}
																		/>
																		{!isEmpty(hasError(entry, "formulaOptionsEntry")) && (
																			<Label basic color="red" className={styles.errorLabel}>
																				{hasError(entry, "formulaOptionsEntry")}
																			</Label>
																		)}
																	</div>
																)}

																{entry.type === "formula" && (
																	<Accordion fluid>
																		<fieldset className={styles.card}>
																			<legend className={styles.legend}>Opciones</legend>
																			{entry.options.length > 0 &&
																				entry.type === "formula" &&
																				entry.options.map((optionLabel, indexs) => {
																					return (
																						<Card key={optionLabel.id} className={styles.fieldset}>
																							<Accordion.Title
																								active={optionLabel.active}
																								index={indexs}
																								onClick={() => {
																									return addFormulaEntry({
																										label: "active",
																										value: !optionLabel.active,
																										entry,
																										id: optionLabel.id,
																									});
																								}}
																								className={styles.accordionTitle}>
																								<div className={styles.divTitle}>
																									<Icon
																										name="trash"
																										negative
																										onClick={(e) => {
																											e.stopPropagation();
																											return rejectFormulaEntry({
																												entry,
																												id: optionLabel.id,
																												labelValidate: ["name", "unit"],
																											});
																										}}
																										disabled={modalOption === "Watch"}
																										className={styles.removeItemButton}
																									/>
																									<div className={styles.boltClass}>
																										<Icon name="dropdown" />
																										{indexs + 1}.{optionLabel.name}
																									</div>
																								</div>
																								{optionLabel.name.length < 2 && (
																									<div>
																										{optionLabel && optionLabel?.name?.length < 2 && (
																											<div>
																												{!isEmpty(hasErrorEntryLabel(entry, "formulaNameEntry", optionLabel)) && (
																													<Label basic color="red" className={styles.errorLabel}>
																														{isEmpty(optionLabel?.name)
																															? hasErrorEntryLabel(entry, "formulaNameEntry", optionLabel)
																															: "Nombre debe tener mínimo 2 caracteres"}
																													</Label>
																												)}
																											</div>
																										)}
																									</div>
																								)}
																							</Accordion.Title>
																							<Accordion.Content active={optionLabel.active}>
																								<Form noValidate>
																									<Grid columns={1}>
																										<Grid.Column width={16}>
																											<div className={styles.container}>
																												<div className={styles.halfWidth}>
																													<span className={styles.label}>
																														Nombre: <span className={styles.required}>*</span>
																													</span>
																													<Input
																														type="text"
																														placeholder="Nombre"
																														name="nameLabel"
																														required
																														value={optionLabel.name}
																														onChange={(e) => {
																															return addFormulaEntry({
																																label: "name",
																																value: e.target.value,
																																entry,
																																id: optionLabel.id,
																															});
																														}}
																														disabled={modalOption === "Watch"}
																														fluid
																													/>
																												</div>

																												<div className={styles.halfWidth}>
																													<span className={styles.label}>Unidad:</span>
																													<Input
																														type="text"
																														placeholder="Ej: Lb, Kg, m2"
																														name="unit"
																														value={optionLabel.unit || ""}
																														onChange={(e) => {
																															return addFormulaEntry({
																																label: "unit",
																																value: e.target.value,
																																entry,
																																id: optionLabel.id,
																															});
																														}}
																														disabled={modalOption === "Watch"}
																														fluid
																													/>
																												</div>
																											</div>
																										</Grid.Column>
																									</Grid>
																								</Form>
																							</Accordion.Content>
																						</Card>
																					);
																				})}
																			<Button
																				type="button"
																				onClick={() => {
																					addOptionFormulaEntry("options", entry);
																				}}
																				className={styles.butttonAdd}
																				disabled={modalOption === "Watch"}>
																				<Icon name="plus" /> Agregar opción
																			</Button>
																		</fieldset>
																	</Accordion>
																)}

																{entry.type === "enum" && (
																	<Accordion fluid>
																		<fieldset className={styles.card}>
																			<legend className={styles.legend}>
																				<div className={styles.containerOptionss}>
																					Opciones
																					<div
																						className={styles.flexEnd}
																						role="button"
																						tabIndex={formEntries.length === 0 ? -1 : 0}
																						onClick={
																							formEntries.length === 0
																								? undefined
																								: () => {
																										return toggleAllAccordionsEntries(entry);
																								  }
																						}
																						disabled={modalOption === "Watch"}>
																						<Icon
																							name={
																								entry.options.every((o) => {
																									return !!o.active;
																								})
																									? "chevron down"
																									: "chevron up"
																							}
																							className={styles.chevronIconPre}
																						/>
																						<Text className={styles.textToggle} disabled={modalOption === "Watch"}>
																							{entry.options.every((o) => {
																								return !!o.active;
																							})
																								? "Colapsar Todas"
																								: "Expandir Todas"}
																						</Text>
																					</div>
																				</div>
																			</legend>
																			{entry.options.length > 0 &&
																				entry.type === "enum" &&
																				entry.options.map((optionLabel, indexs) => {
																					return (
																						<Card key={optionLabel.id} className={styles.fieldset}>
																							<Accordion.Title
																								active={optionLabel.active}
																								index={indexs}
																								onClick={() => {
																									return addEnumEntry({
																										label: "active",
																										value: !optionLabel.active,
																										entry,
																										id: optionLabel.id,
																									});
																								}}
																								className={styles.accordionTitle}>
																								<div className={styles.divTitle}>
																									<Icon
																										name="trash"
																										negative
																										onClick={(e) => {
																											e.stopPropagation();
																											return rejectNameColorEntry({
																												entry,
																												id: optionLabel.id,
																												labelValidate: ["name"],
																											});
																										}}
																										disabled={modalOption === "Watch"}
																										className={styles.removeItemButton}
																									/>
																									<div className={styles.boltClass}>
																										<Icon name="dropdown" />
																										{indexs + 1}.{optionLabel.name}
																									</div>
																								</div>
																								{optionLabel.name.length < 2 && (
																									<div>
																										{optionLabel && optionLabel?.name?.length < 2 && (
																											<div>
																												{!isEmpty(hasErrorEntryLabel(entry, "EnumTypeEntry", optionLabel)) && (
																													<Label basic color="red" className={styles.errorLabel}>
																														{isEmpty(optionLabel?.name)
																															? hasErrorEntryLabel(entry, "EnumTypeEntry", optionLabel)
																															: "Nombre debe tener mínimo 2 caracteres"}
																													</Label>
																												)}
																											</div>
																										)}
																									</div>
																								)}
																							</Accordion.Title>
																							<Accordion.Content active={optionLabel.active}>
																								<Form noValidate>
																									<Grid columns={1}>
																										<Grid.Column width={16}>
																											<div className={styles.container}>
																												<TextAreaInput
																													label="Nombre:"
																													placeholder="Eg. Juan Pérez"
																													name="nameLabel"
																													showRequired
																													value={optionLabel.name}
																													onChange={(e) => {
																														return addEnumEntry({
																															label: "name",
																															value: e.target.value,
																															entry,
																															id: optionLabel.id,
																														});
																													}}
																													disabled={modalOption === "Watch"}
																													minRows={1}
																													maxRows={6}
																													className={styles.inputField}
																												/>
																											</div>
																										</Grid.Column>
																									</Grid>
																								</Form>
																							</Accordion.Content>
																						</Card>
																					);
																				})}
																			<div className={styles.divButtons}>
																				<Button
																					type="button"
																					onClick={() => {
																						addOptionEnumEntry("options", entry);
																					}}
																					className={styles.butttonAdd}
																					disabled={modalOption === "Watch"}>
																					<Icon name="plus" /> Agregar opción
																				</Button>
																				<Button
																					type="button"
																					onClick={() => {
																						addMultipleStringOptions("options", entry);
																					}}
																					className={styles.butttonAdd}
																					disabled={
																						modalOption === "Watch" ||
																						countTokens((find(entry.options, { active: true }) || entry.options[0])?.name || "") < 2
																					}>
																					Multiples
																				</Button>
																			</div>
																		</fieldset>
																	</Accordion>
																)}

																{entry.type === "number" && (
																	<Accordion fluid>
																		<fieldset className={styles.card}>
																			<legend className={styles.legend}>Opciones</legend>
																			{entry.options.length > 0 &&
																				entry.type === "number" &&
																				entry.options.map((optionLabel, indexs) => {
																					return (
																						<Card key={optionLabel.id} className={styles.fieldset}>
																							<Accordion.Title
																								active={optionLabel.active}
																								index={indexs}
																								onClick={() => {
																									return addNumberEntry({
																										label: "active",
																										value: !optionLabel.active,
																										entry,
																										id: optionLabel.id,
																									});
																								}}
																								className={styles.accordionTitle}>
																								<div className={styles.divTitle}>
																									<Icon
																										name="trash"
																										negative
																										onClick={(e) => {
																											e.stopPropagation();
																											return rejectNameColorEntry({
																												entry,
																												id: optionLabel.id,
																												labelValidate: ["name"],
																											});
																										}}
																										disabled={modalOption === "Watch"}
																										className={styles.removeItemButton}
																									/>
																									<div className={styles.boltClass}>
																										<Icon name="dropdown" />
																										{indexs + 1}.{optionLabel.name}
																									</div>
																								</div>
																								{optionLabel.name.length < 2 && (
																									<div>
																										{optionLabel && optionLabel?.name?.length < 2 && (
																											<div>
																												{!isEmpty(hasNumebrErrorEntry(entry, "numberEntry", optionLabel)) && (
																													<Label basic color="red" className={styles.errorLabel}>
																														{isEmpty(optionLabel?.name)
																															? hasNumebrErrorEntry(entry, "numberEntry", optionLabel)
																															: "Nombre debe tener mínimo 2 caracteres"}
																													</Label>
																												)}
																											</div>
																										)}
																									</div>
																								)}
																							</Accordion.Title>
																							<Accordion.Content active={optionLabel.active}>
																								<Form noValidate>
																									<Grid columns={1}>
																										<Grid.Column width={16}>
																											<div className={styles.container}>
																												<div className={styles.halfWidth}>
																													<span className={styles.label}>
																														Nombre: <span className={styles.required}>*</span>
																													</span>
																													<Input
																														type="text"
																														placeholder="Nombre"
																														name="nameLabel"
																														required
																														value={optionLabel.name}
																														onChange={(e) => {
																															return addNumberEntry({
																																label: "name",
																																value: e.target.value,
																																entry,
																																id: optionLabel.id,
																															});
																														}}
																														disabled={modalOption === "Watch"}
																														fluid
																													/>
																												</div>
																											</div>
																										</Grid.Column>
																									</Grid>
																								</Form>
																							</Accordion.Content>
																						</Card>
																					);
																				})}
																			<Button
																				type="button"
																				onClick={() => {
																					addOptionNumberEntry("options", entry);
																				}}
																				className={styles.butttonAdd}
																				disabled={modalOption === "Watch"}>
																				<Icon name="plus" /> Agregar opción
																			</Button>
																		</fieldset>
																	</Accordion>
																)}

																{entry.type === "string" && (
																	<Accordion fluid>
																		<fieldset className={styles.card}>
																			<legend className={styles.legend}>
																				Opciones
																				{/* <div
																						className={styles.flexEnd}
																						role="button"
																						tabIndex={formEntries.length === 0 ? -1 : 0}
																						onClick={
																							formEntries.length === 0
																								? undefined
																								: () => {
																									return toggleAllAccordionsEntries(entry);
																								}
																						}
																						disabled={modalOption === "Watch"}>
																						<Icon
																							name={
																								entry.options.every((o) => {
																									return !!o.active;
																								})
																									? "chevron down"
																									: "chevron up"
																							}
																							className={styles.chevronIconPre}
																						/>
																						<Text className={styles.textToggle} disabled={modalOption === "Watch"}>
																							{entry.options.every((o) => {
																								return !!o.active;
																							})
																								? "Colapsar Todas"
																								: "Expandir Todas"}
																						</Text>
																					</div>
																				</div> */}
																			</legend>

																			{entry.options.length > 0 &&
																				entry.type === "string" &&
																				entry.options.map((optionLabel, indexs) => {
																					return (
																						<Card key={optionLabel.id} className={styles.fieldset}>
																							<Accordion.Title
																								active={optionLabel.active}
																								index={indexs}
																								onClick={() => {
																									return addStringEntry({
																										label: "active",
																										value: !optionLabel.active,
																										entry,
																										id: optionLabel.id,
																									});
																								}}
																								className={styles.accordionTitle}>
																								<div className={styles.divTitle}>
																									<Icon
																										name="trash"
																										negative
																										onClick={(e) => {
																											e.stopPropagation();
																											return rejectNameColorEntry({
																												entry,
																												id: optionLabel.id,
																												labelValidate: ["name"],
																											});
																										}}
																										disabled={modalOption === "Watch"}
																										className={styles.removeItemButton}
																									/>
																									<div className={styles.boltClass}>
																										<Icon name="dropdown" />
																										{indexs + 1}.{optionLabel.name}
																									</div>
																								</div>
																								{optionLabel?.name?.length < 2 && (
																									<div>
																										{optionLabel && optionLabel?.name?.length < 2 && (
																											<div>
																												{!isEmpty(hasTextErrorEntry(entry, "textEntry", optionLabel)) && (
																													<Label basic color="red" className={styles.errorLabel}>
																														{isEmpty(optionLabel?.name)
																															? hasTextErrorEntry(entry, "textEntry", optionLabel)
																															: "Nombre debe tener mínimo 2 caracteres"}
																													</Label>
																												)}
																											</div>
																										)}
																									</div>
																								)}
																							</Accordion.Title>
																							<Accordion.Content active={optionLabel.active}>
																								<Form noValidate>
																									<Grid columns={1}>
																										<Grid.Column width={16}>
																											<div className={styles.container}>
																												<div className={styles.halfWidth}>
																													<TextAreaInput
																														label="Nombre:"
																														placeholder="Eg. Juan Pérez"
																														name="nameLabel"
																														showRequired
																														value={optionLabel.name}
																														onChange={(e) => {
																															addStringEntry({
																																label: "name",
																																value: e.target.value,
																																entry,
																																id: optionLabel.id,
																															});
																														}}
																														disabled={modalOption === "Watch"}
																														minRows={1}
																														maxRows={6}
																														className={styles.inputField}
																													/>
																												</div>
																											</div>
																										</Grid.Column>
																									</Grid>
																								</Form>
																							</Accordion.Content>
																						</Card>
																					);
																				})}
																			<div className={styles.divButtons}>
																				<Button
																					type="button"
																					onClick={() => {
																						addOptionStringEntry("options", entry);
																					}}
																					className={styles.butttonAdd}
																					disabled={modalOption === "Watch"}>
																					<Icon name="plus" /> Agregar opción
																				</Button>
																				{/* <Button
																					type="button"
																					onClick={() => {
																						addMultipleStringOptions("options", entry);
																					}}
																					className={styles.butttonAdd}
																					disabled={
																						modalOption === "Watch" ||
																						countTokens((find(entry.options, { active: true }) || entry.options[0])?.name || "") < 2
																					}>
																					Multiples
																				</Button> */}
																			</div>
																		</fieldset>
																	</Accordion>
																)}

																{entry.type === "label" && (
																	<Accordion fluid>
																		<fieldset className={styles.card}>
																			<legend className={styles.legend}>Opciones</legend>
																			{entry.options.length > 0 &&
																				entry.type === "label" &&
																				entry.options.map((optionLabel, indexs) => {
																					return (
																						<Card key={optionLabel.id} className={styles.fieldset}>
																							<Accordion.Title
																								active={optionLabel.active}
																								index={indexs}
																								onClick={() => {
																									return addNameColorEntry({
																										label: "active",
																										value: !optionLabel.active,
																										entry,
																										id: optionLabel.id,
																									});
																								}}
																								className={styles.accordionTitle}>
																								<div className={styles.divTitle}>
																									<Icon
																										name="trash"
																										negative
																										onClick={(e) => {
																											e.stopPropagation();
																											return rejectNameColorEntry({
																												entry,
																												id: optionLabel.id,
																												labelValidate: ["name", "color"],
																											});
																										}}
																										disabled={modalOption === "Watch"}
																										className={styles.removeItemButton}
																									/>
																									<div className={styles.boltClass}>
																										<Icon name="dropdown" />
																										{indexs + 1}.{optionLabel.name}
																									</div>
																								</div>
																								{optionLabel.name.length < 2 && (
																									<div>
																										{optionLabel && optionLabel?.name?.length < 2 && (
																											<div>
																												{!isEmpty(hasErrorEntryLabel(entry, "labelTypeEntry", optionLabel)) && (
																													<Label basic color="red" className={styles.errorLabel}>
																														{isEmpty(optionLabel?.name)
																															? hasErrorEntryLabel(entry, "labelTypeEntry", optionLabel)
																															: "Nombre debe tener mínimo 2 caracteres"}
																													</Label>
																												)}
																											</div>
																										)}
																									</div>
																								)}
																							</Accordion.Title>
																							<Accordion.Content active={optionLabel.active}>
																								<Form noValidate>
																									<Grid columns={1}>
																										<Grid.Column width={16}>
																											<div className={styles.container}>
																												<div className={styles.halfWidth}>
																													<TextAreaInput
																														label="Texto:"
																														name="nameLabel"
																														value={optionLabel.name}
																														placeholder="Escribe el Nombre"
																														onChange={(e) => {
																															addNameColorEntry({
																																label: "name",
																																value: e.target.value,
																																entry,
																																id: optionLabel.id,
																															});
																														}}
																														disabled={modalOption === "Watch"}
																														minRows={1}
																														maxRows={6}
																														showRequired
																														className={styles.inputField}
																													/>
																												</div>

																												<div className={styles.halfWidth2}>
																													<ColorPickerDropdown
																														currentColor={optionLabel.color}
																														setCurrentColor={(value) => {
																															return addNameColorEntry({
																																label: "color",
																																value,
																																entry,
																																id: optionLabel.id,
																															});
																														}}
																														disabled={modalOption === "Watch"}
																													/>
																												</div>
																											</div>
																										</Grid.Column>
																									</Grid>
																								</Form>
																							</Accordion.Content>
																						</Card>
																					);
																				})}
																			<Button
																				type="button"
																				onClick={() => {
																					addOptionEntry("options", entry);
																				}}
																				className={styles.butttonAdd}
																				disabled={modalOption === "Watch"}>
																				<Icon name="plus" /> Agregar opción
																			</Button>
																		</fieldset>
																	</Accordion>
																)}
															</Grid.Column>
														</Grid>
													</Form>
												</Accordion.Content>
											</Card>
										);
									})}
								<Button type="button" onClick={addListEntry} className={styles.butttonAdd} disabled={modalOption === "Watch"}>
									Agregar Registro
								</Button>
							</fieldset>
							{!isEmpty(errors.formEntries) && (
								<Label basic color="red" className={styles.errorLabel}>
									{errors.formEntries}
								</Label>
							)}
						</Accordion>
					)}
				</fieldset>
			</div>
			{openConfirmModal && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					header="Confirmar Cerrar"
					content="Está seguro que desea salir del formulario"
					onConfirm={confirmModal}
					onDismiss={() => {
						setOpenConfirmModal(false);
					}}
				/>
			)}
			{deleteAlert && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					buttonLabel="Eliminar"
					header="Confirmar Eliminar"
					fullContent={
						<>
							¿Está seguro que desea eliminar <span className={styles.focus}>{itemToDelete?.label}</span>? <br />
							Podría estar vinculado a contactos.
						</>
					}
					onConfirm={handleDeleteConfirm}
					onDismiss={() => {
						setDeleteAlert(false);
						setItemToDelete(null);
					}}
				/>
			)}

			{deleteLabelAlert && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					buttonLabel="Eliminar"
					header="Confirmar Eliminar"
					fullContent={
						<>
							¿Está seguro que desea eliminar la Opción <span className={styles.focus}>{itemToLabelDelete?.name}</span>? <br />
							Podría estar vinculada a contactos.
						</>
					}
					onConfirm={handleDeleteLabelConfirm}
					onDismiss={() => {
						setDeleteLabelAlert(false);
						setItemToLabelDelete(null);
					}}
				/>
			)}

			{deleteFormulaAlert && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					buttonLabel="Eliminar"
					header="Confirmar Eliminar"
					fullContent={
						<>
							¿Está seguro que desea eliminar la Fórmula <span className={styles.focus}>{itemToFormulaDelete?.name}</span>? <br />
							Podría estar vinculada a contactos.
						</>
					}
					onConfirm={handleDeleteFormulaConfirm}
					onDismiss={() => {
						setDeleteFormulaAlert(false);
						setItemToFormulaDelete(null);
					}}
				/>
			)}

			{deleteLabelEntryAlert && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					buttonLabel="Eliminar"
					header="Confirmar Eliminar"
					fullContent={
						<>
							¿Está seguro que desea eliminar la Opción <span className={styles.focus}>{itemToDeleteLabelEntry?.name}</span>? <br />
							Podría estar vinculada a contactos.
						</>
					}
					onConfirm={handleDeleteLabelEntryConfirm}
					onDismiss={() => {
						setDeleteLabelEntryAlert(false);
						setItemToDeleteLabelEntryAlert(null);
					}}
				/>
			)}

			{deleteFormulaEntryAlert && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					buttonLabel="Eliminar"
					header="Confirmar Eliminar"
					fullContent={
						<>
							¿Está seguro que desea eliminar la Fórmula <span className={styles.focus}>{itemToDeleteFormulaEntry?.name}</span>? <br />
							Podría estar vinculada a contactos.
						</>
					}
					onConfirm={handleDeleteFormulaEntryConfirm}
					onDismiss={() => {
						setDeleteFormulaEntryAlert(false);
						setItemToDeleteFormulaEntryAlert(null);
					}}
				/>
			)}
		</IKModal>
	);
};

export default connect()(SystemLogFieldCrud);
